<template>
    <div v-if="storification || story" id="screen-instagram" :class="story && story.isReel && 'screen-reel'" ref="screen-instagram" class="vs-con-loading__container" @mousedown="deselectDragObjects" v-click-outside="deselectDragObjects">
        <div class="centered-line-vertical" ref="widgetCenterVertical" hidden v-if="isDragging" data-html2canvas-ignore></div>
        <div class="centered-line-horizontal" ref="widgetCenterHorizontal" hidden v-if="isDragging" data-html2canvas-ignore></div>
        <div class="rotate-line" ref="widgetRotate" hidden v-if="isRotate" data-html2canvas-ignore></div>
        <div v-if="storification" class="storification" :style="{backgroundColor: screenshotPuppeteer ? 'transparent' : backgroundColor}">
            <video muted v-if="storification.video" class="share-video" :poster="storification.image" :src="storification.video" :style="{opacity: screenshotPuppeteer ? 0 : 1}" ref="main-img" @loadeddata="(e) => loadVideo(e, true)" autoplay loop/>
            <img v-else-if="storification.image" class="share-img" :style="{opacity: screenshotPuppeteer ? 0 : 1}" :src="storification.image" ref="main-img" @load="(e) => loadImage(e, true)" @error="loadImageError"/>
            <p class="share-username" v-if="storification.image || storification.video">@{{storification.username}}</p>
            <img :hidden="!storification.isCarousel" class="carousel-storification" src="../../assets/img/carousel.svg"/>
            <img v-if="storification.video" class="reel-storification-icon" src="../../assets/img/icon_instagram_reel.svg"/>
            <p v-if="storification.video" :hidden="{screenshotPuppeteer}" class="video-time">{{currentStorificationVideoTime}}</p>
            <div v-if="currentMod === Mods.DEFAULT && !screenshotPuppeteer" class="icons-bar" data-html2canvas-ignore>
                <div v-if="!preview" @click="$store.dispatch('addStorificationTextDefault', ''); setMod(Mods.TEXT);" data-no-deselect class="add-text-icon icons"></div>
            </div>
            <div v-if="storification.widgetsReel && !screenshotPuppeteer" class="widget-reels-storification">
                <div v-if="storification.widgetsReel.texts && storification.widgetsReel.texts.length" class="texts-container-view">
                    <div data-no-deselect v-for="(text, idx) in storification.widgetsReel.texts" :key="`textReel-${idx}`" :ref="`textReel-${idx}`" class="textReel" :class="`font${text.font} ${!text.visible && 'text-hide'}`" data-name="TextReel" :data-index="idx" :data-init="text && JSON.stringify(text)" :style="'border: none;'">
                        <span class="text-visualization">{{textsReelComputed[idx]}}</span>
                    </div>
                </div>
                <div v-for="(gif, idx) in storification.widgetsReel.gifs" data-name="GifReel" :data-index="idx" :key="`gif-${idx}`" class="gif" :style="{maxWidth: screenSize.width+'px', border: 'none' }" :data-init="gif && JSON.stringify(gif)">
                    <img data-no-deselect :src="gif.images.preview_gif.url" :style="{maxWidth: (screenSize.width*0.64722222222)+'px'}">
                </div>
                <div v-if="storification.widgetsReel.music" data-name="MusicReel" class="music-container-view">
                    <div class="music-preview" :style="`bottom: 10px; left: 10px; top: unset;`">
                        <img src="https://media.giphy.com/media/0mKYWcPUzB0Jp4qXsh/giphy.gif">
                        <p><b>{{musicReelPreview[0]}}</b> . {{musicReelPreview[1]}} ›</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="story" class="story" :style="{backgroundColor: screenshotPuppeteer ? 'transparent' : (story.video && story.isReel && story.enclosure ? 'white' : backgroundColor)}">
            <!-- <video v-if="story.video" :src="story.video" class="story-image" ref="main-img" autoplay playsinline loop @click="(e) => e.target.paused ? e.target.play() : e.target.pause()"/> -->
            <video v-if="story.video && !screenshotPuppeteer" :src="story.video" class="story-image" ref="main-img" playsinline loop @click="(e) => e.target.paused ? e.target.play() : e.target.pause()" :muted="music ? true : false" :poster="story.isReel && story.enclosure ? story.enclosure : null"/>
            <img v-else-if="story.image && !screenshotPuppeteer" :src="story.image" class="story-image" @load="loadImage" ref="main-img"/>
            <div v-if="currentMod === Mods.DEFAULT && !screenshotPuppeteer" class="icons-bar" data-html2canvas-ignore>
                <div v-if="!story.isReel && !preview" @click="setMod(Mods.RESET)" class="remove-img icons"></div>
                <div v-else-if="story.isReel" class="reel-name">Reels</div>
                <div v-if="!preview">
                    <img v-if="story.image" @click="setMod(Mods.CROPPING)" class="crop-img" src="../../assets/img/icon_instagram_pencil.svg" alt="Crop"/>
                </div>
                <div v-if="!preview" @click="story && story.isReel ? $store.dispatch('addStorificationTextDefaultReel', '') : $store.dispatch('addStorificationTextDefault', ''); setMod(Mods.TEXT);" data-no-deselect class="add-text-icon icons"></div>
            </div>
            <div v-if="currentMod === Mods.RESET" class="popup-remove-img" data-html2canvas-ignore>
                <div class="txt-container-remove-img">
                    <h3 class="title-remove-img">Abandonner la photo ?</h3>
                    <div class="txt-remove-img"> Si vous revenez en arrière maintenant, vous perdrez votre template</div>
                </div>
                <div class="btn-remove-img">
                    <button @click.prevent="setMod(Mods.DEFAULT)" class="cancel-remove-img" tabindex="0">Conserver</button>
                    <button @click.prevent="$store.dispatch('resetStorification'); $store.dispatch('emitData', {message: 'resetStory'}); setMod(Mods.DEFAULT);" class="confirm-remove-img" tabindex="0">Abandonner</button>
                </div>
            </div>
            <div v-if="currentMod === Mods.CROPPING" class="crop-mod" data-html2canvas-ignore>
                <span @click="setMod(Mods.DEFAULT)" class="crop-btns crop-cancel">Annuler</span>
                <span @click="confirmCrop()" class="crop-btns crop-confirm">Sauvegarder</span>
                <div class="crop-slider-size">
                    <img class="crop-size" src="../../assets/img/icon_instagram_loupe_plus.svg" alt="+">
                    <input @input="cropperZoom" data-old-value="1" class="crop-slider" type="range" value="1" step="0.05" min="0" max="2" dir="rtl" />
                    <img class="crop-size" src="../../assets/img/icon_instagram_loupe_moins.svg" alt="-">
                </div>
                <div class="crop-actions" >
                    <img @click="() => cropper.rotate(45)" src="../../assets/img/icon_instagram_rotate.svg" alt="rotate +">
                    <img @click="() => cropper.rotate(-45)" src="../../assets/img/icon_instagram_rotate_neg.svg" alt="rotate -">
                    <img @click="() => cropper.scaleX(cropper.getImageData().scaleX * -1)" src="../../assets/img/icon_instagram_inverse_x.svg" alt="inverse x">
                    <img @click="() => cropper.scaleY(cropper.getImageData().scaleY * -1)" src="../../assets/img/icon_instagram_inverse_y.svg" alt="inverse y">
                </div>
                
            </div>
        </div>
        <div v-if="texts && texts.length" class="texts-container-view" :style="currentMod === Mods.CROPPING && 'display: none;'">
            <div data-no-deselect v-for="(text, idx) in texts" :key="`text-${idx}`" :ref="`text-${idx}`" class="text" :class="`interactable-${_uid} draggable-${_uid} clickable-${_uid} font${text.font} ${!text.visible && 'text-hide'}`" data-name="Text" :data-index="idx" :data-init="text && JSON.stringify(text)" @clickableCustomFuntion="() => {selectedObject = idx; setMod(Mods.TEXT);}" :style="(text.background == 0 && text.content.trim() !== '' && currentMod === Mods.TEXT && selectedObject === idx) ? 'border: rgba(255, 255, 255, 0.3) solid 1px; border-radius: 0;'+`text-align: ${text.justification || 'center'};` : 'border: none; ' + (text.minWidth) && `min-width: ${!(currentMod === Mods.TEXT && selectedObject === idx) ? text.minWidth + 20 : 0}px; text-align: ${text.justification || 'center'};`">
                <contenteditable data-no-deselect v-if="currentMod === Mods.TEXT && selectedObject === idx" tag="span" :contenteditable="true" @keydown="(e) => minWidthText(e, idx)" v-model="text.content" :noNL="false" :noHTML="true"/>
                <!-- <contenteditable data-no-deselect v-else tag="span" :contenteditable="false" v-model="textsComputed[idx]" :noNL="false" :noHTML="true"/> -->
                <span v-else class="text-visualization">{{textsComputed[idx]}}</span>
                <!-- <span v-else class="text-visualization">{{text.content}}</span> -->
                <img data-no-deselect :hidden="!(currentMod === Mods.TEXT && selectedObject === idx)" class="rotation-icon no-hover" :class="`rotation-${_uid}`" src="../../assets/img/icon_instagram_rotate_txt.svg"/>
            </div>
            <div v-if="currentMod === Mods.TEXT" class="text-mod" @mouseup="() => setTextFocus()" data-html2canvas-ignore>
                <div class="text-actions">
                    <img data-no-deselect class="text-justify" @click="textJustify()" :src="require(`../../assets/img/icon_instagram_justify_${textJustification}.png`)">
                    <img data-no-deselect class="text-color-view" @click="textColorView = !textColorView" src="../../assets/img/icon_instagram_color.png" alt="">
                    <img data-no-deselect class="text-background" data-value="0" @click="(e) => textSpecialsModifications(selectedObject, {background: (texts[selectedObject].background + 1)%(texts[selectedObject].font === 3 ? 2 : 3)})" :src="require(`../../assets/img/icon_instagram_fond${texts[selectedObject].background === 0 ? 1 : 2}.png`)">
                    <span data-no-deselect @click="setMod(Mods.DEFAULT)" class="text-end">Terminer</span>
                </div>
                <div class="text-slider-size">
                    <img data-no-deselect class="text-size" src="../../assets/img/icon_instagram_txt_plus.png" alt="+">
                    <input data-no-deselect @input="(e) => textSpecialsModifications(selectedObject, {size: e.target.value})" class="text-slider" type="range" :value="texts[selectedObject].size" step="1" min="15" max="75" dir="rtl" />
                    <img data-no-deselect class="text-size" src="../../assets/img/icon_instagram_txt_moins.png" alt="-">
                </div>
                <div v-if="textColorView" class="text-colors">
                    <div data-no-deselect v-for="color in textColors" @click="() => textSpecialsModifications(selectedObject, {color})" :key="color" class="color" :style="{backgroundColor: color, borderColor: color === 'white' ? 'black': 'white'}"></div>
                </div>
                <div class="text-fonts" v-if="!isDragging">
                    <span data-no-deselect v-for="idx in 4" :key="idx" @click="() => textSpecialsModifications(selectedObject, {font: idx})" :class="`font${idx} font`" :style="texts[selectedObject].font === idx ? 'background-color: white; color: #ba3420;' : 'background-color: #26262670; color: white;'">Aa</span>
                    <span data-no-deselect :key="10" @click="() => textSpecialsModifications(selectedObject, {font: 10})" :class="`font${10} font`" :style="texts[selectedObject].font === 10 ? 'background-color: white; color: #ba3420;' : 'background-color: #26262670; color: white;'">Aa</span>
                    <span data-no-deselect :key="11" @click="() => textSpecialsModifications(selectedObject, {font: 11})" :class="`font${11} font`" :style="texts[selectedObject].font === 11 ? 'background-color: white; color: #ba3420;' : 'background-color: #26262670; color: white;'">Aa</span>
                </div>
            </div>
        </div>
        <div v-if="link && link.url && link.isActive" :style="currentMod === Mods.CROPPING && 'display: none;'" :class="`interactable-${_uid} draggable-${_uid} resizable-${_uid} colorable-${_uid} link-container-view style-color-0`" data-name="Link" :data-init="link.initialDatas && JSON.stringify(link.initialDatas)" data-number-style-color="4"> 
            <img class="link-img" src="../../assets/img/icon_instagram_link.svg" alt="Link">
            <p class="link-txt">{{link.text ? link.text.toUpperCase() : link.url.split('/')[2].toUpperCase().split('?')[0].replace('WWW.', '')}}</p>
            <div class="corner edge-top edge-left"></div><div class="corner edge-top edge-right"></div><div class="corner edge-bottom edge-right"></div><div class="corner edge-bottom edge-left"></div>
            <img :hidden="!!preview" data-no-deselect class="rotation-icon" :class="`rotation-${_uid}`" src="../../assets/img/icon_instagram_rotate_txt.svg"/>
        </div>

        <div v-for="(layer, idx) in layers" data-name="Layer" :data-index="idx" :key="`layer-${idx}`" class="layer" :class="`interactable-${_uid} draggable-${_uid} resizable-${_uid}`" :style="{maxWidth: screenSize.width+'px',maxHeight: screenSize.height+'px', display: currentMod === Mods.CROPPING ? 'none' : 'block'}" :data-init="layer && JSON.stringify(layer)">
            <img :src="layer.reader || layer.url" :style="{maxWidth: screenSize.width+'px'}">
            <div class="corner edge-top edge-left"></div><div class="corner edge-top edge-right"></div><div class="corner edge-bottom edge-right"></div><div class="corner edge-bottom edge-left"></div>
            <!-- <img :hidden="!!preview" data-no-deselect class="rotation-icon" :class="`rotation-${_uid}`" src="../../assets/img/icon_instagram_rotate_txt.svg"/> -->
        </div>

        <div v-for="(gif, idx) in gifs" data-name="Gif" @mousedown="selectedObject = 'gif_'+gif.id" :data-index="idx" :key="`gif-${idx}`" class="gif" :class="`interactable-${_uid} draggable-${_uid} resizable-${_uid}`" :style="{maxWidth: screenSize.width+'px', border: `gif_${gif.id}` === selectedObject ? '2px solid rgb(222, 6, 136)' : 'none', display: currentMod === Mods.CROPPING || screenshotPuppeteer ? 'none' : '' }" :data-init="gif && JSON.stringify(gif)">
            <img data-no-deselect :src="gif.images.preview_gif.url" :style="{maxWidth: screenSize.width+'px'}">
            <div data-no-deselect class="corner edge-top edge-left"></div><div data-no-deselect class="corner edge-top edge-right"></div><div data-no-deselect class="corner edge-bottom edge-right"></div><div data-no-deselect class="corner edge-bottom edge-left"></div>
            <img :hidden="`gif_${gif.id}` !== selectedObject" data-no-deselect class="rotation-icon no-hover" :class="`rotation-${_uid}`" src="../../assets/img/icon_instagram_rotate_txt.svg"/>
        </div>

        <div v-if="music && !screenshotPuppeteer" :style="currentMod === Mods.CROPPING && 'display: none;'" data-name="Music" class="music-container-view">
            <audio @canplaythrough="(e) => e.target.volume = '0.5'" @timeupdate="(e) => {if($refs['music-percent']) $refs['music-percent'].style.width = `${100 * ((e.target.currentTime*1000) - music.start) / (music.end - music.start)}%`; if((e.target.currentTime*1000) > music.end) e.target.currentTime = music.start/1000 }" ref="music-story-player" :src="music.track.fast_start_progressive_download_url"></audio>
            <!-- <div v-if="music && music.config" class="music-back-dark"></div> -->
            <div v-if="music.config && !preview" class="music-config">
                <select @focus="story && story.isReel ? $store.commit('updateStorificationMusicReel', {paused: true}) : $store.commit('updateStorificationMusic', {paused: true})" @change="e => story.isReel ? $store.commit('updateStorificationMusicReel', {duration: parseInt(e.target.value)*1000}) : $store.commit('updateStorificationMusic', {duration: parseInt(e.target.value)*1000})" v-if="!isVideo" class="timer-music">
                    <option :selected="k === music.duration/1000" :key="k" v-for="k of [5,6,7,8,9,10,11,12,13,14,15]" :value="k">{{k}}</option>
                </select>
                <select disabled v-else class="timer-music">
                    <option  :value="music.duration/1000">{{Math.round(music.duration/1000)}}</option>
                </select>
                <vue-slider class="slider" :value="[music.start, music.end]" dotSize="10" :fixed="true" :min="0" :max="music.track.duration_in_ms" :tooltip-formatter="(ms) => `${Math.floor(ms / 60000)}:${String(Math.round((ms % 60000) / 1000)).padStart(2, '0')}`" :marks="music.track.highlight_start_times_in_ms" :hide-label="true" @drag-end="() => {}" @drag-start="() => {}" @change="([start, end]) => story.isReel ? $store.commit('updateStorificationMusicReel', {start}) : $store.commit('updateStorificationMusic', {start})" :dotStyle="{visibility: 'hidden', width: '50px'}" :processStyle="{backgroundColor: 'white', zIndex: 1000}" :railStyle="{backgroundColor: 'rgb(94,86,83)', height: 'inherit'}"/>
                <vs-icon class="control" v-if="!music.paused" @click="story && story.isReel ? $store.commit('updateStorificationMusicReel', {paused: true}) : $store.commit('updateStorificationMusic', {paused: true})" icon="stop_circle"></vs-icon>
                <vs-icon class="control" v-else @click="story && story.isReel ? $store.commit('updateStorificationMusicReel', {paused: false}) : $store.commit('updateStorificationMusic', {paused: false})" icon="play_arrow"></vs-icon>
                <div class="music-position-container"><div :style="{left: positionMusicBar}" class="music-position"></div></div>
                <div class="music-progress">
                    <div ref="music-percent" class="music-percent"></div>
                </div>
            </div>
            <div v-else class="music-preview" :style="(story && story.isReel && `bottom: 10px; left: 10px; top: unset;`) || (preview && `top: 10px; left: 5px;`)">
                <img src="https://media.giphy.com/media/0mKYWcPUzB0Jp4qXsh/giphy.gif">
                <p><b>{{musicPreview[0]}}</b> . {{musicPreview[1]}} ›</p>
            </div>
        </div>

        <div v-if="poll && !screenshotPuppeteer" :style="currentMod === Mods.CROPPING && 'display: none;'" class="poll-container-view" data-name="Poll" :class="`interactable-${_uid} draggable-${_uid} resizable-${_uid}`" :data-init="poll && JSON.stringify(poll)">
            <div v-if="pollHasQuestion" class="poll-question">
                <p class="">{{poll.question || "Question ?"}}</p>
            </div>
            <div class="poll-choices" :style="!pollHasQuestion && 'border-top-left-radius: 10px; border-top-right-radius: 10px;'">
                <span :class="`choice-container${!pollHasQuestion ? ' no-question' : ''}`"><span class="text-choice" id="poll-option-1">{{poll.options[0] || "Oui"}}</span></span>
                <span :class="`choice-container${!pollHasQuestion ? ' no-question' : ''}`"><span class="text-choice" id="poll-option-2">{{poll.options[1] || "Non"}}</span></span>
                <span v-if="poll.options[2]" :class="`choice-container${!pollHasQuestion ? ' no-question' : ''}`"><span class="text-choice" id="poll-option-2">{{poll.options[2]}}</span></span>
                <span v-if="poll.options[3]" :class="`choice-container${!pollHasQuestion ? ' no-question' : ''}`"><span class="text-choice" id="poll-option-2">{{poll.options[3]}}</span></span>
            </div>
            <div class="corner edge-top edge-left"></div><div class="corner edge-top edge-right"></div><div class="corner edge-bottom edge-right"></div><div class="corner edge-bottom edge-left"></div>
            <img :hidden="!!preview" data-no-deselect class="rotation-icon" :class="`rotation-${_uid}`" src="../../assets/img/icon_instagram_rotate_txt.svg"/>
        </div>

        <div v-if="slider && !screenshotPuppeteer" :style="currentMod === Mods.CROPPING && 'display: none;'" ref="slider" class="slider-container-view" :class="`interactable-${_uid} draggable-${_uid} resizable-${_uid} colorable-${_uid} style-color-0`" data-name="Slider" data-number-style-color="9" :data-init="slider && JSON.stringify(slider)">
            <p v-if="slider.question" class="slider-question">{{slider.question || "Question ?"}}</p>
            <div class="slider-slide">
            <span class="emoji">{{slider.emoji}}</span>
            <div class="bar"></div>
            </div>
            <div class="corner edge-top edge-left"></div><div class="corner edge-top edge-right"></div><div class="corner edge-bottom edge-right"></div><div class="corner edge-bottom edge-left"></div>
            <img :hidden="!!preview" data-no-deselect class="rotation-icon" :class="`rotation-${_uid}`" src="../../assets/img/icon_instagram_rotate_txt.svg"/>
        </div>

        <div v-if="question && !screenshotPuppeteer" :style="currentMod === Mods.CROPPING && 'display: none;'" :class="`interactable-${_uid} draggable-${_uid} resizable-${_uid} colorable-${_uid} question-container-view style-color-0`" data-name="Question" :data-init="question && JSON.stringify(question)" data-number-style-color="9"> 
            <img class="question-avatar" :src="question.avatar ? question.avatar : (informations.pageInfo.avatar || 'https://s3.eu-west-1.amazonaws.com/saas.mashup/static-assets/avatar_instagram.png')" alt="Avatar">
            <p class="question-txt">{{question.text || "Posez-moi une question"}}</p>
            <p class="question-resp">Entrez quelque chose...</p>
            <div class="corner edge-top edge-left"></div><div class="corner edge-top edge-right"></div><div class="corner edge-bottom edge-right"></div><div class="corner edge-bottom edge-left"></div>
            <img :hidden="!!preview" data-no-deselect class="rotation-icon" :class="`rotation-${_uid}`" src="../../assets/img/icon_instagram_rotate_txt.svg"/>
        </div>

         <div v-if="location" :style="currentMod === Mods.CROPPING && 'display: none;'" ref="location" class="mentions-container-view" :class="`interactable-${_uid} draggable-${_uid} resizable-${_uid} colorable-${_uid} style-color-0`" data-name="Location" data-number-style-color="4" :data-init="location && JSON.stringify(location)">
            <span v-if="location.color === 3" class="location-widget-text">
                <svg baseProfile="tiny" height="24px" id="Layer_1" version="1.2" viewBox="0 0 24 24" width="24px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="g1" x1="0.14" y1="0.15" x2="0.86" y2="0.85"><stop offset="9%" stop-color="#f6d860"/><stop offset="18%" stop-color="#ed894b"/><stop offset="28%" stop-color="#d53a42"/><stop offset="62%" stop-color="#ea3469"/><stop offset="77%" stop-color="#ed64a6"/><stop offset="92%" stop-color="#7638fa"/></linearGradient></defs><path fill='url(#g1)' d="M17.657,5.304c-3.124-3.073-8.189-3.073-11.313,0c-3.124,3.074-3.124,8.057,0,11.13L12,21.999l5.657-5.565  C20.781,13.361,20.781,8.378,17.657,5.304z M12,13.499c-0.668,0-1.295-0.26-1.768-0.732c-0.975-0.975-0.975-2.561,0-3.536  c0.472-0.472,1.1-0.732,1.768-0.732s1.296,0.26,1.768,0.732c0.975,0.975,0.975,2.562,0,3.536C13.296,13.239,12.668,13.499,12,13.499  z"/></svg>
                <span class="location-name">{{location.name}}</span>
            </span>
            <span v-else-if="location.color === 2" class="location-widget-text">
                <svg baseProfile="tiny" height="24px" id="Layer_1" version="1.2" viewBox="0 0 24 24" width="24px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs> <linearGradient id="g1" x1="0.14" y1="0.15" x2="0.86" y2="0.85"> <stop offset="9%" stop-color="#f6d860"/><stop offset="18%" stop-color="#ed894b"/><stop offset="28%" stop-color="#d53a42"/><stop offset="62%" stop-color="#ea3469"/><stop offset="77%" stop-color="#ed64a6"/><stop offset="92%" stop-color="#7638fa"/></linearGradient></defs><path fill='url(#g1)' d="M17.657,5.304c-3.124-3.073-8.189-3.073-11.313,0c-3.124,3.074-3.124,8.057,0,11.13L12,21.999l5.657-5.565  C20.781,13.361,20.781,8.378,17.657,5.304z M12,13.499c-0.668,0-1.295-0.26-1.768-0.732c-0.975-0.975-0.975-2.561,0-3.536  c0.472-0.472,1.1-0.732,1.768-0.732s1.296,0.26,1.768,0.732c0.975,0.975,0.975,2.562,0,3.536C13.296,13.239,12.668,13.499,12,13.499  z"/></svg>
                <span class="location-name">{{location.name}}</span>
            </span>
            <span v-else class="location-widget-text">
                <svg baseProfile="tiny" height="24px" id="Layer_1" version="1.2" viewBox="0 0 24 24" width="24px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M17.657,5.304c-3.124-3.073-8.189-3.073-11.313,0c-3.124,3.074-3.124,8.057,0,11.13L12,21.999l5.657-5.565  C20.781,13.361,20.781,8.378,17.657,5.304z M12,13.499c-0.668,0-1.295-0.26-1.768-0.732c-0.975-0.975-0.975-2.561,0-3.536  c0.472-0.472,1.1-0.732,1.768-0.732s1.296,0.26,1.768,0.732c0.975,0.975,0.975,2.562,0,3.536C13.296,13.239,12.668,13.499,12,13.499  z"/></svg>
                <span class="location-name">{{location.name}}</span>
            </span>
            <div class="corner edge-top edge-left"></div><div class="corner edge-top edge-right"></div><div class="corner edge-bottom edge-right"></div><div class="corner edge-bottom edge-left"></div>
            <img :hidden="!!preview" data-no-deselect class="rotation-icon" :class="`rotation-${_uid}`" src="../../assets/img/icon_instagram_rotate_txt.svg"/>
        </div>

        <div v-if="product && product.items && product.items.length && !screenshotPuppeteer" :style="currentMod === Mods.CROPPING && 'display: none;'" ref="product" class="mentions-container-view" :class="`interactable-${_uid} draggable-${_uid} resizable-${_uid} colorable-${_uid} style-color-0`" data-name="Product" data-number-style-color="4" :data-init="product && JSON.stringify(product)">
            <!-- <span v-if="product.color === 3" class="product-widget-text">
                <svg  viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"><path :fill="backgroundColor" d="M -299.7 -54 C -298.6 -53.2 -298 -52.3 -297.8 -51 C -297.8 -51 -297.8 -50.7 -297.8 -50.7 C -297.8 -50.7 -297.8 -50.6 -297.8 -50.6 C -297.8 -50.6 -297.8 -50.6 -297.8 -50.6 C -297.8 -50.6 -297.8 -50.6 -297.8 -50.6 C -297.5 -50.6 -297.1 -50.6 -297 -50.6 C -296.7 -50.6 -296.7 -50.6 -296.5 -50.6 C -295.3 -50.6 -295.3 -50.6 -294.9 -50.4 C -294.9 -50.4 -294.9 -50.4 -294.8 -50.4 C -294.2 -49.9 -293.5 -49.5 -293.3 -48.8 C -293.3 -48.7 -293.3 -48.4 -293.2 -47.9 C -293.2 -47.9 -293.2 -47.9 -293.2 -47.9 C -293.2 -47.7 -293.2 -47.6 -293.2 -47.6 C -293.2 -47.3 -293.2 -47.3 -293.2 -47.3 C -293.2 -46.8 -293.2 -46.6 -293.2 -46.4 C -293.2 -46.2 -293.2 -46 -293.2 -45.7 C -292.9 -45.3 -292.9 -44.9 -292.9 -44.5 C -292.9 -44.1 -292.6 -43.5 -292.6 -42.9 C -292.6 -42.5 -292.6 -41.9 -292.6 -41.6 C -292.6 -41.4 -292.6 -41.2 -292.4 -40.8 C -292.4 -40.7 -292.4 -40.5 -292.4 -40.3 C -292.4 -40.1 -292.4 -40.1 -292.4 -40.1 C -292.4 -40 -292.4 -39.6 -292.4 -39.6 C -292.4 -39.6 -292.4 -39.6 -292.4 -39.6 C -292.2 -38.1 -292.6 -36.7 -293.5 -35.7 C -294.8 -34.6 -295.9 -34 -297.5 -33.6 C -297.8 -33.6 -298 -33.6 -298.6 -33.6 C -298.6 -33.6 -298.7 -33.6 -298.7 -33.6 C -298.9 -33.6 -299.2 -33.6 -299.4 -33.6 C -299.8 -33.6 -300.2 -33.6 -300.3 -33.6 C -300.8 -33.6 -301.3 -33.6 -302 -33.6 C -302.4 -33.6 -302.9 -33.6 -303.5 -33.6 C -304 -33.6 -304.3 -33.6 -304.8 -33.6 C -305.1 -33.6 -305.5 -33.6 -305.8 -33.6 C -305.9 -33.6 -306.2 -33.6 -306.4 -33.6 C -306.4 -33.6 -306.7 -33.6 -306.7 -33.6 C -308.2 -33.6 -309.6 -34 -310.7 -35.1 C -310.7 -35.1 -310.7 -35.1 -310.7 -35.1 C -311.8 -35.9 -312.4 -37.3 -312.8 -38.5 C -312.8 -38.8 -312.8 -39 -312.8 -39.2 C -312.8 -39.2 -312.8 -39.2 -312.8 -39.2 C -312.8 -39.6 -312.4 -40.1 -312.4 -40.5 C -312.4 -40.5 -312.4 -40.7 -312.4 -40.7 C -312.4 -40.8 -312.4 -41.2 -312.4 -41.4 C -312.4 -41.6 -312.4 -41.8 -312.4 -41.8 C -312.3 -42.3 -312.3 -42.7 -312.3 -43.4 C -312.3 -43.8 -312.3 -44.2 -312.1 -44.6 C -312.1 -45 -312.1 -45.6 -312.1 -46 C -312.1 -46.2 -312.1 -46.4 -311.8 -46.6 C -311.8 -46.8 -311.8 -47.2 -311.8 -47.3 C -311.8 -47.6 -311.8 -47.6 -311.8 -47.7 C -311.8 -48.7 -311.6 -49.3 -310.7 -49.9 C -310.2 -50.4 -309.6 -50.6 -308.9 -50.6 C -308.9 -50.6 -308.9 -50.6 -308.9 -50.6 C -308.6 -50.6 -308.5 -50.6 -308.2 -50.6 C -308.2 -50.6 -308.2 -50.6 -307.9 -50.6 C -307.8 -50.6 -307.5 -50.6 -307.4 -50.6 C -307.4 -50.6 -307.4 -50.6 -307.4 -50.6 C -307.4 -51.8 -306.7 -52.8 -305.8 -53.7 C -304.1 -55.1 -301.4 -55.5 -299.7 -54 Z M -304.7 -52.3 C -305.1 -51.7 -305.2 -51.3 -305.2 -50.6 C -303.5 -50.6 -301.6 -50.6 -299.8 -50.6 C -299.8 -51.3 -300.2 -51.8 -300.5 -52.3 C -301 -52.9 -302 -53.2 -302.5 -53.2 C -303.2 -53.2 -304.1 -52.8 -304.7 -52.3 Z M -306.8 -46.6 C -307.4 -46.2 -307 -45.7 -307 -45.3 C -306.8 -44.5 -306.4 -43.8 -305.9 -43.1 C -305.9 -43.1 -305.9 -43.1 -305.9 -43.1 C -305.1 -42.3 -304 -41.8 -302.9 -41.8 C -301.4 -41.6 -300.3 -41.9 -299.2 -42.9 C -298.6 -43.8 -298 -44.9 -297.8 -46 C -297.8 -46.4 -298 -46.6 -298.3 -46.6 C -298.6 -46.8 -298.7 -46.8 -298.9 -46.8 C -299.2 -46.8 -299.4 -46.8 -299.4 -46.6 C -299.7 -46.4 -299.7 -46.2 -299.8 -46 C -299.8 -45 -300.2 -44.5 -300.8 -44.1 C -301.4 -43.5 -302.1 -43.4 -303 -43.5 C -303.7 -43.5 -304.3 -44.1 -304.8 -44.6 C -305.1 -45 -305.2 -45.6 -305.2 -46 C -305.2 -46.4 -305.2 -46.4 -305.8 -46.8 C -305.9 -46.8 -305.9 -47.2 -306.4 -46.8 C -306.7 -46.8 -306.7 -46.8 -306.8 -46.6 Z" transform="matrix(1,0,0,1,314.1,55.9)"/></svg>
                <span :style="{color: backgroundColor}" class="product-name">{{product.items.length > 1 ? `${product.items.length} produits` : product.items[0].text}}</span>
            </span> -->
            <span v-if="product.color === 2" class="product-widget-text">
                <svg  viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"><defs><linearGradient id="g1" x1="0.14" y1="0.15" x2="0.86" y2="0.85"> <stop offset="9%" stop-color="#f6d860"/><stop offset="18%" stop-color="#ed894b"/><stop offset="28%" stop-color="#d53a42"/><stop offset="62%" stop-color="#ea3469"/><stop offset="77%" stop-color="#ed64a6"/><stop offset="92%" stop-color="#7638fa"/></linearGradient></defs><path fill='url(#g1)' d="M -299.7 -54 C -298.6 -53.2 -298 -52.3 -297.8 -51 C -297.8 -51 -297.8 -50.7 -297.8 -50.7 C -297.8 -50.7 -297.8 -50.6 -297.8 -50.6 C -297.8 -50.6 -297.8 -50.6 -297.8 -50.6 C -297.8 -50.6 -297.8 -50.6 -297.8 -50.6 C -297.5 -50.6 -297.1 -50.6 -297 -50.6 C -296.7 -50.6 -296.7 -50.6 -296.5 -50.6 C -295.3 -50.6 -295.3 -50.6 -294.9 -50.4 C -294.9 -50.4 -294.9 -50.4 -294.8 -50.4 C -294.2 -49.9 -293.5 -49.5 -293.3 -48.8 C -293.3 -48.7 -293.3 -48.4 -293.2 -47.9 C -293.2 -47.9 -293.2 -47.9 -293.2 -47.9 C -293.2 -47.7 -293.2 -47.6 -293.2 -47.6 C -293.2 -47.3 -293.2 -47.3 -293.2 -47.3 C -293.2 -46.8 -293.2 -46.6 -293.2 -46.4 C -293.2 -46.2 -293.2 -46 -293.2 -45.7 C -292.9 -45.3 -292.9 -44.9 -292.9 -44.5 C -292.9 -44.1 -292.6 -43.5 -292.6 -42.9 C -292.6 -42.5 -292.6 -41.9 -292.6 -41.6 C -292.6 -41.4 -292.6 -41.2 -292.4 -40.8 C -292.4 -40.7 -292.4 -40.5 -292.4 -40.3 C -292.4 -40.1 -292.4 -40.1 -292.4 -40.1 C -292.4 -40 -292.4 -39.6 -292.4 -39.6 C -292.4 -39.6 -292.4 -39.6 -292.4 -39.6 C -292.2 -38.1 -292.6 -36.7 -293.5 -35.7 C -294.8 -34.6 -295.9 -34 -297.5 -33.6 C -297.8 -33.6 -298 -33.6 -298.6 -33.6 C -298.6 -33.6 -298.7 -33.6 -298.7 -33.6 C -298.9 -33.6 -299.2 -33.6 -299.4 -33.6 C -299.8 -33.6 -300.2 -33.6 -300.3 -33.6 C -300.8 -33.6 -301.3 -33.6 -302 -33.6 C -302.4 -33.6 -302.9 -33.6 -303.5 -33.6 C -304 -33.6 -304.3 -33.6 -304.8 -33.6 C -305.1 -33.6 -305.5 -33.6 -305.8 -33.6 C -305.9 -33.6 -306.2 -33.6 -306.4 -33.6 C -306.4 -33.6 -306.7 -33.6 -306.7 -33.6 C -308.2 -33.6 -309.6 -34 -310.7 -35.1 C -310.7 -35.1 -310.7 -35.1 -310.7 -35.1 C -311.8 -35.9 -312.4 -37.3 -312.8 -38.5 C -312.8 -38.8 -312.8 -39 -312.8 -39.2 C -312.8 -39.2 -312.8 -39.2 -312.8 -39.2 C -312.8 -39.6 -312.4 -40.1 -312.4 -40.5 C -312.4 -40.5 -312.4 -40.7 -312.4 -40.7 C -312.4 -40.8 -312.4 -41.2 -312.4 -41.4 C -312.4 -41.6 -312.4 -41.8 -312.4 -41.8 C -312.3 -42.3 -312.3 -42.7 -312.3 -43.4 C -312.3 -43.8 -312.3 -44.2 -312.1 -44.6 C -312.1 -45 -312.1 -45.6 -312.1 -46 C -312.1 -46.2 -312.1 -46.4 -311.8 -46.6 C -311.8 -46.8 -311.8 -47.2 -311.8 -47.3 C -311.8 -47.6 -311.8 -47.6 -311.8 -47.7 C -311.8 -48.7 -311.6 -49.3 -310.7 -49.9 C -310.2 -50.4 -309.6 -50.6 -308.9 -50.6 C -308.9 -50.6 -308.9 -50.6 -308.9 -50.6 C -308.6 -50.6 -308.5 -50.6 -308.2 -50.6 C -308.2 -50.6 -308.2 -50.6 -307.9 -50.6 C -307.8 -50.6 -307.5 -50.6 -307.4 -50.6 C -307.4 -50.6 -307.4 -50.6 -307.4 -50.6 C -307.4 -51.8 -306.7 -52.8 -305.8 -53.7 C -304.1 -55.1 -301.4 -55.5 -299.7 -54 Z M -304.7 -52.3 C -305.1 -51.7 -305.2 -51.3 -305.2 -50.6 C -303.5 -50.6 -301.6 -50.6 -299.8 -50.6 C -299.8 -51.3 -300.2 -51.8 -300.5 -52.3 C -301 -52.9 -302 -53.2 -302.5 -53.2 C -303.2 -53.2 -304.1 -52.8 -304.7 -52.3 Z M -306.8 -46.6 C -307.4 -46.2 -307 -45.7 -307 -45.3 C -306.8 -44.5 -306.4 -43.8 -305.9 -43.1 C -305.9 -43.1 -305.9 -43.1 -305.9 -43.1 C -305.1 -42.3 -304 -41.8 -302.9 -41.8 C -301.4 -41.6 -300.3 -41.9 -299.2 -42.9 C -298.6 -43.8 -298 -44.9 -297.8 -46 C -297.8 -46.4 -298 -46.6 -298.3 -46.6 C -298.6 -46.8 -298.7 -46.8 -298.9 -46.8 C -299.2 -46.8 -299.4 -46.8 -299.4 -46.6 C -299.7 -46.4 -299.7 -46.2 -299.8 -46 C -299.8 -45 -300.2 -44.5 -300.8 -44.1 C -301.4 -43.5 -302.1 -43.4 -303 -43.5 C -303.7 -43.5 -304.3 -44.1 -304.8 -44.6 C -305.1 -45 -305.2 -45.6 -305.2 -46 C -305.2 -46.4 -305.2 -46.4 -305.8 -46.8 C -305.9 -46.8 -305.9 -47.2 -306.4 -46.8 C -306.7 -46.8 -306.7 -46.8 -306.8 -46.6 Z" transform="matrix(1,0,0,1,314.1,55.9)"/></svg>
                <span class="product-name">{{product.items.length > 1 ? `${product.items.length} ${$t('dash.post.text.product') + 's'}` : (product.items[0].text.length > 30 ? product.items[0].text.slice(0,30) + "..." : product.items[0].text)}}</span>
            </span>
            <span v-else class="product-widget-text">
                <svg  viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"><path d="M -299.7 -54 C -298.6 -53.2 -298 -52.3 -297.8 -51 C -297.8 -51 -297.8 -50.7 -297.8 -50.7 C -297.8 -50.7 -297.8 -50.6 -297.8 -50.6 C -297.8 -50.6 -297.8 -50.6 -297.8 -50.6 C -297.8 -50.6 -297.8 -50.6 -297.8 -50.6 C -297.5 -50.6 -297.1 -50.6 -297 -50.6 C -296.7 -50.6 -296.7 -50.6 -296.5 -50.6 C -295.3 -50.6 -295.3 -50.6 -294.9 -50.4 C -294.9 -50.4 -294.9 -50.4 -294.8 -50.4 C -294.2 -49.9 -293.5 -49.5 -293.3 -48.8 C -293.3 -48.7 -293.3 -48.4 -293.2 -47.9 C -293.2 -47.9 -293.2 -47.9 -293.2 -47.9 C -293.2 -47.7 -293.2 -47.6 -293.2 -47.6 C -293.2 -47.3 -293.2 -47.3 -293.2 -47.3 C -293.2 -46.8 -293.2 -46.6 -293.2 -46.4 C -293.2 -46.2 -293.2 -46 -293.2 -45.7 C -292.9 -45.3 -292.9 -44.9 -292.9 -44.5 C -292.9 -44.1 -292.6 -43.5 -292.6 -42.9 C -292.6 -42.5 -292.6 -41.9 -292.6 -41.6 C -292.6 -41.4 -292.6 -41.2 -292.4 -40.8 C -292.4 -40.7 -292.4 -40.5 -292.4 -40.3 C -292.4 -40.1 -292.4 -40.1 -292.4 -40.1 C -292.4 -40 -292.4 -39.6 -292.4 -39.6 C -292.4 -39.6 -292.4 -39.6 -292.4 -39.6 C -292.2 -38.1 -292.6 -36.7 -293.5 -35.7 C -294.8 -34.6 -295.9 -34 -297.5 -33.6 C -297.8 -33.6 -298 -33.6 -298.6 -33.6 C -298.6 -33.6 -298.7 -33.6 -298.7 -33.6 C -298.9 -33.6 -299.2 -33.6 -299.4 -33.6 C -299.8 -33.6 -300.2 -33.6 -300.3 -33.6 C -300.8 -33.6 -301.3 -33.6 -302 -33.6 C -302.4 -33.6 -302.9 -33.6 -303.5 -33.6 C -304 -33.6 -304.3 -33.6 -304.8 -33.6 C -305.1 -33.6 -305.5 -33.6 -305.8 -33.6 C -305.9 -33.6 -306.2 -33.6 -306.4 -33.6 C -306.4 -33.6 -306.7 -33.6 -306.7 -33.6 C -308.2 -33.6 -309.6 -34 -310.7 -35.1 C -310.7 -35.1 -310.7 -35.1 -310.7 -35.1 C -311.8 -35.9 -312.4 -37.3 -312.8 -38.5 C -312.8 -38.8 -312.8 -39 -312.8 -39.2 C -312.8 -39.2 -312.8 -39.2 -312.8 -39.2 C -312.8 -39.6 -312.4 -40.1 -312.4 -40.5 C -312.4 -40.5 -312.4 -40.7 -312.4 -40.7 C -312.4 -40.8 -312.4 -41.2 -312.4 -41.4 C -312.4 -41.6 -312.4 -41.8 -312.4 -41.8 C -312.3 -42.3 -312.3 -42.7 -312.3 -43.4 C -312.3 -43.8 -312.3 -44.2 -312.1 -44.6 C -312.1 -45 -312.1 -45.6 -312.1 -46 C -312.1 -46.2 -312.1 -46.4 -311.8 -46.6 C -311.8 -46.8 -311.8 -47.2 -311.8 -47.3 C -311.8 -47.6 -311.8 -47.6 -311.8 -47.7 C -311.8 -48.7 -311.6 -49.3 -310.7 -49.9 C -310.2 -50.4 -309.6 -50.6 -308.9 -50.6 C -308.9 -50.6 -308.9 -50.6 -308.9 -50.6 C -308.6 -50.6 -308.5 -50.6 -308.2 -50.6 C -308.2 -50.6 -308.2 -50.6 -307.9 -50.6 C -307.8 -50.6 -307.5 -50.6 -307.4 -50.6 C -307.4 -50.6 -307.4 -50.6 -307.4 -50.6 C -307.4 -51.8 -306.7 -52.8 -305.8 -53.7 C -304.1 -55.1 -301.4 -55.5 -299.7 -54 Z M -304.7 -52.3 C -305.1 -51.7 -305.2 -51.3 -305.2 -50.6 C -303.5 -50.6 -301.6 -50.6 -299.8 -50.6 C -299.8 -51.3 -300.2 -51.8 -300.5 -52.3 C -301 -52.9 -302 -53.2 -302.5 -53.2 C -303.2 -53.2 -304.1 -52.8 -304.7 -52.3 Z M -306.8 -46.6 C -307.4 -46.2 -307 -45.7 -307 -45.3 C -306.8 -44.5 -306.4 -43.8 -305.9 -43.1 C -305.9 -43.1 -305.9 -43.1 -305.9 -43.1 C -305.1 -42.3 -304 -41.8 -302.9 -41.8 C -301.4 -41.6 -300.3 -41.9 -299.2 -42.9 C -298.6 -43.8 -298 -44.9 -297.8 -46 C -297.8 -46.4 -298 -46.6 -298.3 -46.6 C -298.6 -46.8 -298.7 -46.8 -298.9 -46.8 C -299.2 -46.8 -299.4 -46.8 -299.4 -46.6 C -299.7 -46.4 -299.7 -46.2 -299.8 -46 C -299.8 -45 -300.2 -44.5 -300.8 -44.1 C -301.4 -43.5 -302.1 -43.4 -303 -43.5 C -303.7 -43.5 -304.3 -44.1 -304.8 -44.6 C -305.1 -45 -305.2 -45.6 -305.2 -46 C -305.2 -46.4 -305.2 -46.4 -305.8 -46.8 C -305.9 -46.8 -305.9 -47.2 -306.4 -46.8 C -306.7 -46.8 -306.7 -46.8 -306.8 -46.6 Z" transform="matrix(1,0,0,1,314.1,55.9)"/></svg>
                <span class="product-name">{{product.items.length > 1 ? `${product.items.length} ${$t('dash.post.text.product') + 's'}` : (product.items[0].text.length > 30 ? product.items[0].text.slice(0,30) + "..." : product.items[0].text)}}</span>
            </span>
            <div class="corner edge-top edge-left"></div><div class="corner edge-top edge-right"></div><div class="corner edge-bottom edge-right"></div><div class="corner edge-bottom edge-left"></div>
            <img :hidden="!!preview" data-no-deselect class="rotation-icon" :class="`rotation-${_uid}`" src="../../assets/img/icon_instagram_rotate_txt.svg"/>
        </div>

        <div v-for="(mention, idx) in mentions" :key="mention.pk" :style="currentMod === Mods.CROPPING && 'display: none;'" :class="`interactable-${_uid} draggable-${_uid} resizable-${_uid} colorable-${_uid} style-color-0 ${mention.hide ? 'hidden-mention' : ''}`" class="mentions-container-view" data-name="Mention" :data-index="idx" :data-init="mention && JSON.stringify(mention)" data-number-style-color="4">
            <span v-if="mention.color === 3" class="mention-widget-text"><span class="arobase">@</span>{{mention.id}}</span>
            <span v-else class="mention-widget-text">@{{mention.id}}</span>
            <div class="corner edge-top edge-left"></div><div class="corner edge-top edge-right"></div><div class="corner edge-bottom edge-right"></div><div class="corner edge-bottom edge-left"></div>
            <img :hidden="!!preview" data-no-deselect class="rotation-icon" :class="`rotation-${_uid}`" src="../../assets/img/icon_instagram_rotate_txt.svg"/>
        </div>

        <div v-for="(hashtag, idx) in hashtags" :key="hashtag.hashtag" :style="currentMod === Mods.CROPPING && 'display: none;'" :class="`interactable-${_uid} draggable-${_uid} resizable-${_uid} colorable-${_uid} style-color-0 ${hashtag.hide ? 'hidden-mention' : ''}`" class="mentions-container-view" data-name="Hashtag" :data-index="idx" :data-init="hashtag && JSON.stringify(hashtag)" data-number-style-color="4">
            <span v-if="hashtag.color === 3" class="mention-widget-text"><span class="arobase">#</span>{{hashtag.hashtag}}</span>
            <span v-else class="mention-widget-text hashtag">#{{hashtag.hashtag}}</span>
            <div class="corner edge-top edge-left"></div><div class="corner edge-top edge-right"></div><div class="corner edge-bottom edge-right"></div><div class="corner edge-bottom edge-left"></div>
            <img :hidden="!!preview" data-no-deselect class="rotation-icon" :class="`rotation-${_uid}`" src="../../assets/img/icon_instagram_rotate_txt.svg"/>
        </div>


        <img v-if="template && template.config && template.config !== 'custom'" class="template-img" :src="`https://s3.eu-west-1.amazonaws.com/saas.mashup/static-assets/${template.config}.png`">

        <img :hidden="!isDragging" :class="`dropzone-${_uid}`" class="delete-widget" src="../../assets/img/icon_instagram_trash.svg" data-html2canvas-ignore/>

        <div v-if="pageIsConnectedConciergerie && informations.highlight && !preview && currentMod !== Mods.CROPPING && story && !story.isReel && !screenshotPuppeteer" class="highlight-container" data-html2canvas-ignore>
            <div v-if="highlight.popup" @click="() => {highlight.popup=false; isValidHightlight && $store.commit('updateStorificationHightlight', highlight.current === '__new_highlight__' ? highlight.create : highlight.current)}" class="close-highlight"></div>
            <p class="p-highlight" v-if="highlight.popup">Ajouter aux éléments à la une</p>
            <div v-if="highlight.popup" class="highlights vs-con-loading__container" ref="loadingHighlight">  
                <label class="highlight">
                    <vs-radio class="hidden" v-model="highlight.current" :vs-value="null"></vs-radio>
                    <div class="highlight-img" :style="highlight.current === null && 'border: solid 2.5px white'">X</div>
                    Aucun
                </label>
                <label v-for="h of highlight.pages" class="highlight" :key="h.id">
                    <vs-radio class="hidden" @change="() => {highlight.popup=false; isValidHightlight && $store.commit('updateStorificationHightlight', highlight.current === '__new_highlight__' ? highlight.create : highlight.current)}" v-model="highlight.current" :vs-value="h.id"></vs-radio>
                    <img :src="h.img" alt="" class="highlight-img" :style="highlight.current === h.id && 'border: solid 2.5px white'">
                    {{h.title}}
                </label>
                <label class="highlight">
                    <vs-radio class="hidden" v-model="highlight.current" vs-value="__new_highlight__"></vs-radio>
                    <div class="highlight-img" :style="highlight.current === '__new_highlight__' && 'border: solid 2.5px white'">+</div>
                    <vs-input v-model="highlight.create" class="new-highlight" size="small" :style="highlight.current === '__new_highlight__' && 'border: solid 1px white'" :danger="!isValidHightlight" danger-text="Invalide"></vs-input>
                </label>
            </div>
            <img v-if="!highlight.popup" class="highlight-icon icons-white" @click="openHighlight" :src="currentHighlightThumbnail" alt="">
        </div>
    </div>
</template>

<script>
import ColorThief from 'color-thief-browser';
import FastAverageColor from 'fast-average-color';
import Posts from './../mixins/Posts'
import Bots from './../mixins/Bots'
import interact from "interactjs";
import Cropper from 'cropperjs';
import VueSlider from 'vue-slider-component';
import ClickOutside from 'vue-click-outside'
// import html2canvas from'html2canvas-fitcontain'
import 'cropperjs/dist/cropper.css';
import 'vue-slider-component/theme/antd.css';

const screenSize = {width: 360, height: 640}
const namesNeedUseWidth = ["Layer", "Gif", "GifReel"];
const Mods = {
    DEFAULT: 0,
    CROPPING: 1,
    TEXT: 2,
    RESET: 3
}

const textColors = ['#fdcb5c', '#fd8d32', '#db565b', '#d10869', '#a207ba', '#0095ff', '#58c322', 'black', 'white'];

export default {
    components: {
        VueSlider
    },
    directives: {ClickOutside},
    mixins: [Posts, Bots],
    mounted() {

        if (this.screenshotPuppeteer) {
            // let screenInstagram = document.getElementById("screen-instagram");
            let screenInstagram = document.querySelector("#screen-instagram:not(.screen-reel)");
            screenInstagram.style.scale = 3;
            screenInstagram.style.top = "300px";
            screenInstagram.style.left = "2000px";
            screenInstagram.style.borderRadius = 0;
            // screenInstagram.style.background = 'transparent';
            let currentElement = screenInstagram
            while (currentElement) {
                // Set background to transparent
                // currentElement.style.backgroundColor = 'rgba(255, 255, 255, 0);';
                currentElement.style.background = 'transparent';
                // currentElement.style.opacity = 0;
                currentElement.style.border = "none";
                // Move to the parent element
                currentElement = currentElement.parentElement;
            }

            document.querySelector('.loader-mw').style.background = 'transparent'
        }

        console.log("MOUNT STORIFICATION", this._uid);
        if (!this.preview) {
            interact(`.rotation-${this._uid}`)
            .draggable({
                listeners: {
                    start: (event) => {
                        this.isRotate = true
                        let rect = event.target.parentElement.getBoundingClientRect();
                        event.target.parentElement.setAttribute('data-rotation-center-x', rect.left + rect.width / 2);
                        event.target.parentElement.setAttribute('data-rotation-center-y', rect.top + rect.height / 2);
                    },
                    move: this.moveRotation,
                    end: [(e) => this.updateStoreWithPosition({target: e.target.parentElement}), () => this.$nextTick(() => this.isRotate = false)]
                }
            })
            interact(`.dropzone-${this._uid}`)
            .dropzone({
                checker: (dragEvent, event, dropped, dropzone, dropzoneElement, draggable, draggableElement) => {
                    return dragEvent.type === 'dragend' && event.target === dropzoneElement;
                },
                ondrop: (event) => {
                    this.$vs.dialog({
                        type:'confirm',
                        color: 'danger',
                        "accept-text": this.$t("dash.button.delete"),
                        "cancel-text": this.$t("dash.button.cancel"),
                        title: `${this.$t("dash.button.delete")} ?`,
                        text: this.$t("dash.story.remove.widget.confirm"),
                        accept: () => {
                            const name = event.relatedTarget.getAttribute('data-name');
                            const index = event.relatedTarget.getAttribute('data-index');
                            this.story && this.story.isReel && ["Text", "Gif", "Music"].includes(name) ? this.$store.commit(`removeStorification${name}Reel`, index) : this.$store.commit(`removeStorification${name}`, index);
                            this.setMod(Mods.DEFAULT);
                        }
                    })
                },
            })
            interact(`.interactable-${this._uid}`)
            .draggable({
                allowFrom: `.draggable-${this._uid}`,
                modifiers: [
                    interact.modifiers.restrictRect({
                        restriction: this.$refs['screen-instagram'],
                    }),
                ],
                listeners: {
                    start: () => this.isDragging = true,
                    move: this.moveDraggable,
                    end: [this.updateStoreWithPosition, () => this.$nextTick(() => this.isDragging = false)]
                }
            })
            .resizable({
                allowFrom: `.resizable-${this._uid}`,
                edges: { left: '.edge-left', right: '.edge-right', bottom: '.edge-bottom', top: '.edge-top'},
                listeners: { 
                    move: (e) => this.moveResizable(e, namesNeedUseWidth.includes(e.target.getAttribute('data-name'))),
                    end: this.updateStoreWithPosition
                },
                modifiers: [
                    interact.modifiers.restrictEdges({
                        outer: this.$refs['screen-instagram'],
                    }),
                    interact.modifiers.restrictSize({
                        min: { width: 50, height: 10 },
                        max: { width: screenSize.width, height: screenSize.height }
                    }),
                    interact.modifiers.aspectRatio({
                        ratio: 'preserve' 
                    })
                ]
            })
            interact(`.colorable-${this._uid}`).on('tap', this.changeColor);
            interact(`.clickable-${this._uid}`).on('tap', (e) => {
                e.currentTarget.dispatchEvent(new CustomEvent("clickableCustomFuntion"));
            });
            
            this.initDatas();
        } else {
            this.$nextTick(() => {
                for (let [key, value] of Object.entries(this.preview)) {
                    if (Array.isArray(value)) {
                        for (let [index, val] of value.entries()) {
                            this.updatePreview(key, val, index);
                        }
                    } else {
                        this.updatePreview(key, value);
                    }
                }
            })
        }
        console.log(this.storification);
        
        if (this.storification && this.storification.widgetsReel) {
            console.log("WIDGETREEL");
            
            this.$nextTick(() => {
                let preview = {
                    'TextReel': this.storification.widgetsReel.texts,
                    'GifReel': this.storification.widgetsReel.gifs,
                    'MusicReel': this.storification.widgetsReel.music,
                }
                for (let [key, value] of Object.entries(preview)) {
                    if (Array.isArray(value)) {
                        for (let [index, val] of value.entries()) {
                            this.updatePreview(key, val, index);
                        }
                    } else {
                        this.updatePreview(key, value);
                    }
                }
            })
        }

    },
    watch: {
        async currentMod(newVal, oldVal) {
            console.log(newVal, oldVal);
            if (newVal === Mods.DEFAULT) {
                //Exit a Mod
                switch (oldVal) {
                    case Mods.CROPPING:
                        this.cropper.destroy();
                        this.cropper = null;
                        break;
                    case Mods.TEXT:
                        if (this.texts[this.selectedObject].content.endsWith('\n')) {
                            this.texts[this.selectedObject].content = this.texts[this.selectedObject].content.trimEnd();
                        }
                        this.selectedObject = null;
                        break;
                    default:
                        break;
                }
            } else {
                //Enter in a Mod
                switch (newVal) {
                    case Mods.CROPPING: {
                        if (!this.$refs['main-img'].src.includes('blob')) {
                            await this.repairCorsImage(this.$refs['main-img'].src);
                        }
                        this.cropper = new Cropper(this.$refs['main-img'], {aspectRatio: screenSize.width/screenSize.height, dragMode: 'move', cropBoxMovable: false, cropBoxResizable: false, minCropBoxWidth: screenSize.width, minCropBoxHeight: screenSize.height, zoomOnWheel: false});
                        break;
                    }
                    case Mods.TEXT: {
                        if (this.selectedObject == null || (typeof this.selectedObject === 'string' && this.selectedObject.includes('gif_'))) {
                            this.selectedObject = (this.texts.length - 1);
                        }
                        break;
                    }
                    default:
                        break;
                    
                }
            }
        },
        '$store.getters.emittedObject': {
            handler: async function(emittedObject) {
                // if (emittedObject && emittedObject.message === "captureStoryScreenshot") {
                //     this.$store.commit('updateStorificationScreenshot', null);
                //     this.setMod(Mods.DEFAULT);
                //     this.selectedObject = null;
                //     if (this.$refs['main-img']) {
                //         let imageSrc = this.$refs['main-img'].src;
                //         let imageBlob = await fetch(imageSrc, {cache: 'no-cache'}).then(res => res.blob());
                //         this.$refs['main-img'].onload = () => {
                //             this.$refs['main-img'].onload = null;
                //             this.$vs.loading({container: this.$refs['screen-instagram'], color: '#43153D'})
                //             html2canvas(this.$refs['screen-instagram'], {allowTaint: true, useCORS:true, backgroundColor: this.backgroundColor, scale: 2}).then(async canvas => {
                //                 let imageB64 = canvas.toDataURL('image/png')
                //                 const newImageBlob = await fetch(imageB64).then(res => res.blob())
                //                 const newFile = new File([newImageBlob], `story-screenshot-${this._uid}.png`); //Blob to file
                //                 let formData = new FormData()
                //                 formData.append('file', newFile)
                //                 await this.$http.post(`${process.env.VUE_APP_API_HOST}/posts/upload/file`, formData)
                //                 .then(res => {
                //                     this.$vs.loading.close(this.$refs['screen-instagram']);
                //                     emittedObject.data.screenshot = res.body.file_url;
                //                 }, err => {
                //                     this.$vs.loading.close(this.$refs['screen-instagram']);
                //                     emittedObject.data.screenshot = err;
                //                 })
                //             })
                //         }
                //         this.$refs['main-img'].src = URL.createObjectURL(imageBlob);
                //     } else {
                //         this.$vs.loading({container: this.$refs['screen-instagram'], color: '#43153D'})
                //         html2canvas(this.$refs['screen-instagram'], {allowTaint: true, useCORS:true, backgroundColor: this.backgroundColor, scale: 2}).then(async canvas => {
                //             let imageB64 = canvas.toDataURL('image/png')
                //             const newImageBlob = await fetch(imageB64).then(res => res.blob())
                //             const newFile = new File([newImageBlob], `story-screenshot-${this._uid}.png`); //Blob to file
                //             let formData = new FormData()
                //             formData.append('file', newFile)
                //             await this.$http.post(`${process.env.VUE_APP_API_HOST}/posts/upload/file`, formData)
                //             .then(res => {
                //                 this.$vs.loading.close(this.$refs['screen-instagram']);
                //                 emittedObject.data.screenshot = res.body.file_url;
                //             }, err => {
                //                 this.$vs.loading.close(this.$refs['screen-instagram']);
                //                 emittedObject.data.screenshot = err;
                //             })
                //         })
                //     }
                    
                // }
            }
        },
        selectedObject(newVal, oldVal) {
            console.log(this.currentMod, newVal, oldVal);
            switch (this.currentMod) {
                case Mods.TEXT: {
                    if (newVal != oldVal) {
                        this.setTextFocus();
                    }
                }
            }
        },
        preview(newVal, oldVal) {
            console.log('preview');
            if (newVal) {
                console.log("preview", newVal);
                for (let [key, value] of Object.entries(newVal)) {
                    if (Array.isArray(value)) {
                        for (let [index, val] of value.entries()) {
                            this.updatePreview(key, val, index);
                        }
                    } else {
                        this.updatePreview(key, value);
                    }
                }
            }
        },
        backgroundColor(newVal, oldVal) {
            console.log("backgroundColor", newVal, oldVal);
            if (!newVal && oldVal && !this.preview) {
                this.$nextTick(() => {
                    let mainImage = this.$refs["main-img"];
                    if (mainImage) {
                        if (mainImage.tagName === "VIDEO") {
                            this.loadVideo({target: mainImage}, !!this.storification);
                        } else {
                            this.loadImage({target: mainImage});
                        }
                    }
                })
                
            }
        },
        "link.initialDatas"(newVal, oldVal) {
            if (!oldVal && !this.preview) {
                console.log("watcher: initData link.initialDatas");
                this.$nextTick(this.initDatas);
            }
        },
        "link.url"(newVal, oldVal) {
            if (!oldVal && !this.preview) {
                console.log("watcher: initData link.url");
                this.$nextTick(this.initDatas);
            }
        },
        "music.paused"(newVal, oldVal) {
            console.log("watcher: music.paused", newVal, oldVal);
            if (newVal != null && !this.preview) {
                this.$nextTick(() => {
                    newVal ? (this.$refs['music-story-player'].pause() && this.isVideo && this.$refs['main-img'].pause()) : (this.$refs['music-story-player'].play() && this.isVideo && this.$refs['main-img'].play());
                });
            }
        },
        "music.start"(newVal, oldVal) {
            console.log("watcher: music.start", newVal, oldVal);
            if (newVal != null && !this.preview) {
                this.$nextTick(() =>  {
                    this.$refs['music-story-player'].currentTime = newVal/1000;
                    if (this.isVideo) this.$refs['main-img'].currentTime = newVal/1000;
                });
            }
        },
        texts(newVal, oldVal) {
            if (newVal.length !== oldVal.length && !this.preview) {
                console.log("watcher: initData texts");
                this.$nextTick(this.initDatas);
            }
        },
        mentions(newVal, oldVal) {
            if (newVal.length !== oldVal.length && !this.preview) {
                console.log("watcher: initData mentions");
                this.$nextTick(this.initDatas);
            }
        },
        hashtags(newVal, oldVal) {
            if (newVal.length !== oldVal.length && !this.preview) {
                console.log("watcher: initData hashtags");
                this.$nextTick(this.initDatas);
            }
        },
        gifs(newVal, oldVal) {
            if (newVal.length !== oldVal.length && !this.preview) {
                console.log("watcher: initData gifs");
                this.$nextTick(this.initDatas);
            }
        },
        poll(newVal, oldVal) {
            if (newVal && !oldVal && !this.preview) {
                console.log("watcher: initData pool");
                this.$nextTick(this.initDatas);
            }
        },
        slider(newVal, oldVal) {
            if (newVal && !oldVal && !this.preview) {
                console.log("watcher: initData slider");
                this.$nextTick(this.initDatas);
            }
        },
        question(newVal, oldVal) {
            if (newVal && !oldVal && !this.preview) {
                console.log("watcher: initData question");
                this.$nextTick(this.initDatas);
            }
        },
        location(newVal, oldVal) {
            if (newVal && !oldVal && !this.preview) {
                console.log("watcher: initData location");
                this.$nextTick(this.initDatas);
            }
        },
        product(newVal, oldVal) {
            if (newVal && !oldVal && !this.preview) {
                console.log("watcher: initData product");
                this.$nextTick(this.initDatas);
            }
        },
        "template.config"(newVal) {
            if (newVal === 'custom' && this.template.custom && !this.preview) {
                this.$store.commit("updateStorificationLayers", this.template.custom.configuration.layers);
                this.$store.commit("updateStorificationBackgroundColor", this.template.custom.configuration.background);
                if (this.texts && this.texts.length) {
                    let {x, y, w, h, size, font, background, color} = this.template.custom.configuration.text;
                    w = (w / (1440 / this.screenSize.width))
                    h = (h / (1440 / this.screenSize.width))
                    x = (x / (1440 / this.screenSize.width)) - (w/2)
                    y = (y / (1440 / this.screenSize.width)) - (h/2)
                    let element = document.querySelector(`[data-name="Text"][data-index="0"]`);
                    element.setAttribute('data-init',JSON.stringify({x, y, w, h, size, font, background:background || 0, color}));
                }
                if (this.link && this.link.url) {
                    let {x, y, w, h, custom_cta} = this.template.custom.configuration.link;
                    w = (w / (1440 / this.screenSize.width))
                    h = (h / (1440 / this.screenSize.width))
                    x = (x / (1440 / this.screenSize.width)) - (w/2)
                    y = (y / (1440 / this.screenSize.width)) - (h/2)
                    let element = document.querySelector(`[data-name="Link"]`);
                    element.setAttribute('data-init',JSON.stringify({x, y, w, h, text: custom_cta}));
                }
                this.initDatas();
            }
        },
        "storification.widgetsReel"(newVal) {
            if (newVal) {
                let preview = {
                    'TextReel': newVal.texts,
                    'GifReel': newVal.gifs,
                    'MusicReel': newVal.music,
                }
                for (let [key, value] of Object.entries(preview)) {
                    if (Array.isArray(value)) {
                        for (let [index, val] of value.entries()) {
                            this.updatePreview(key, val, index);
                        }
                    } else {
                        this.updatePreview(key, value);
                    }
                }
            }
        },
        "$store.getters.storificationHightlight"(newVal) {
            this.highlight.current = newVal;
        }
    },
    data() {
        return {
            cropper: null,
            currentMod: Mods.DEFAULT,
            textJustification: 0,
            textColorView: false,
            highlight: {popup: false, current: null, pages: [], create: ''},
            selectedObject: null,
            isDragging: false,
            isRotate: false,
            textColors,
            Mods,
            screenSize,
            currentStorificationVideoTime: 0,
        }
    },
    props: {
        storification: Object,
        story: Object,
        backgroundColor: String,
        link: Object,
        texts: Array,
        layers: Array,
        gifs: Array,
        music: Object,
        poll: Object,
        slider: Object,
        question: Object,
        mentions: Array,
        hashtags: Array,
        location: Object,
        product: Object,
        template: Object,
        preview: {type: Object, default: null},
        informations: Object
    },
    methods: {

        minWidthText(e, index) {
            let minWidth = e.target.parentElement.getBoundingClientRect().width;
            this.story && this.story.isReel ? this.$store.commit(`updateStorificationTextReel`, {minWidth}) : this.$store.commit(`updateStorificationText`, {minWidth, index});
        },

        deselectDragObjects(e) {
            console.log("deselectDragObjects", e.target.getAttribute("data-no-deselect"));
            if (e && e.target.getAttribute("data-no-deselect") == null) {
                this.currentMod === Mods.TEXT ? this.setMod(Mods.DEFAULT) : this.selectedObject = null;
            }
        },

        openHighlight() {
            if (this.highlight.popup === false && this.highlight.pages.length === 0) {
                this.getHighlightsInstagram({id: this.informations.pageInfo.id}).then(res => {
                            console.log(res.body.highlights);
                            this.highlight.pages = res.body.highlights
                });
            }
            this.highlight.popup = true;
        },

        textJustify() {
            this.textJustification = (this.textJustification + 1) % 3;
            let textElement = this.$refs[`text-${this.selectedObject}`][0];
            let evt;
            if (this.textJustification === 0) {
                evt = {dx: ((screenSize.width)/2) - parseFloat(textElement.getAttribute('data-x')) - (parseFloat(textElement.getAttribute('data-w')/2)), dy: ((screenSize.height)/2) - parseFloat(textElement.getAttribute('data-y')) - (parseFloat(textElement.getAttribute('data-h')/2)), target: textElement, rect: {width: textElement.offsetWidth, height: textElement.offsetHeight}};
                this.story && this.story.isReel ? this.$store.commit(`updateStorificationTextReel`, {justification: "center", index: this.selectedObject}) : this.$store.commit(`updateStorificationText`, {justification: "center", index: this.selectedObject});
            } else if (this.textJustification === 1) {
                evt = {dx: (textElement.offsetWidth/2) + 20 - parseFloat(textElement.getAttribute('data-x')) - (parseFloat(textElement.getAttribute('data-w')/2)), dy: ((screenSize.height)/2) - parseFloat(textElement.getAttribute('data-y')) - (parseFloat(textElement.getAttribute('data-h')/2)), target: textElement, rect: {width: textElement.offsetWidth, height: textElement.offsetHeight}};
                this.story && this.story.isReel ? this.$store.commit(`updateStorificationTextReel`, {justification: "start", index: this.selectedObject}) : this.$store.commit(`updateStorificationText`, {justification: "start", index: this.selectedObject});
            } else {
                evt = {dx: (screenSize.width - (textElement.offsetWidth/2) - 20) - parseFloat(textElement.getAttribute('data-x')) - (parseFloat(textElement.getAttribute('data-w')/2)), dy: ((screenSize.height)/2) - parseFloat(textElement.getAttribute('data-y')) - (parseFloat(textElement.getAttribute('data-h')/2)), target: textElement, rect: {width: textElement.offsetWidth, height: textElement.offsetHeight}};
                this.story && this.story.isReel ? this.$store.commit(`updateStorificationTextReel`, {justification: "end", index: this.selectedObject}) : this.$store.commit(`updateStorificationText`, {justification: "end", index: this.selectedObject});
            }
            this.moveDraggable(evt);
            this.updateStoreWithPosition(evt);
        },

        async setTextFocus() {
            this.$nextTick(() => {
                const textElement = this.$refs[`text-${this.selectedObject}`][0].childNodes[0];
                console.log("setTextFocus",textElement);
                textElement.focus();
                let range = document.createRange(); //Create a range (a range is a like the selection but invisible)
                range.selectNodeContents(textElement); //Select the entire contents of the element with the range
                range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
                let selection = window.getSelection(); //get the selection object (allows you to change selection)
                selection.removeAllRanges(); //remove any selections already made
                selection.addRange(range); //make the range you have just created the visible selection
            });
        },

        async confirmCrop() {
            const newImageB64 = this.cropper.getCroppedCanvas().toDataURL("image/png");
            const newImageBlob = await fetch(newImageB64).then(res => res.blob())
            this.$store.dispatch(`emitData`, {message: "updateCroppedImage", data: newImageBlob})
            this.setMod(Mods.DEFAULT);
        },

        cropperZoom(event) {
            const oldValue = parseFloat(event.target.getAttribute('data-old-value'));
            const newValue = parseFloat(event.target.value);
            const zoom = (newValue > oldValue) ? 0.1 : -0.1;
            event.target.setAttribute('data-old-value', event.target.value)
            this.cropper.zoom(zoom)
        },

        moveDraggable(event) {
            let x = parseFloat(event.target.getAttribute('data-x') ? event.target.getAttribute('data-x') : (event.target.offsetWidth/2));
            let y = parseFloat(event.target.getAttribute('data-y') ? event.target.getAttribute('data-y') : (event.target.offsetHeight/2));
            x += event.dx;
            y += event.dy;
            event.target.setAttribute("data-x", x);
            event.target.setAttribute("data-y", y);
            // let angle = parseFloat(event.target.getAttribute('data-angle')) || 0;
            // let cosPhi = Math.abs(Math.cos(angle));
            // let sinPhi = Math.abs(Math.sin(angle));
            // let currentWidth = Math.min((event.rect.width * cosPhi - event.rect.height * sinPhi) / (cosPhi * cosPhi - sinPhi * sinPhi), screenSize.width);
            // let currentHeight = (event.rect.height * cosPhi - event.rect.width * sinPhi) / (cosPhi * cosPhi - sinPhi * sinPhi);
            event.target.setAttribute("data-w", event.target.offsetWidth);
            event.target.setAttribute("data-h", event.target.offsetHeight);
            let scale = parseFloat(event.target.getAttribute('data-scale') || 1);
            if (this.$refs.widgetCenterVertical && this.isDragging) {
                this.$refs.widgetCenterVertical.hidden = !((x+(event.rect.width/2/scale)) > (screenSize.width/2)-2 && (x+(event.rect.width/2/scale)) < (screenSize.width/2)+2);
            } 
            if (this.$refs.widgetCenterHorizontal && this.isDragging) {
                this.$refs.widgetCenterHorizontal.hidden = !((y+(event.rect.height/2/scale)) > (screenSize.height/2)-2 && (y+(event.rect.height/2/scale)) < (screenSize.height/2)+2);
            } 
            // event.target.style.top = `${y - (event.target.offsetHeight/2)}px`;
            event.target.style.top = `${y}px`;
            // event.target.style.left = `${x - (event.target.offsetWidth/2)}px`;
            event.target.style.left = `${x}px`;
        },

        moveResizable(event, useWidth=false) {
            let angle = parseFloat(event.target.getAttribute('data-angle')) || 0;
            let cosPhi = Math.abs(Math.cos(angle));
            let sinPhi = Math.abs(Math.sin(angle));
            console.log(angle, cosPhi, sinPhi, event.rect);
            let currentWidth = Math.min((event.rect.width * cosPhi - event.rect.height * sinPhi) / (cosPhi * cosPhi - sinPhi * sinPhi), screenSize.width);
            let currentHeight = (event.rect.height * cosPhi - event.rect.width * sinPhi) / (cosPhi * cosPhi - sinPhi * sinPhi);
            console.log("moveResizable", useWidth, event.target,event.target.offsetWidth, currentWidth, event.rect.width);
            let scale = useWidth ? 1 : parseFloat(currentWidth/(event.target.offsetWidth || 146))
            if (scale > 2) scale = parseFloat(event.target.getAttribute('data-scale') || 1);
            console.log("SCALE:",scale);
            event.target.setAttribute("data-scale", scale);
            if (useWidth) {
                event.target.style.width = currentWidth + 'px';
                // event.target.style.height = event.rect.height + 'px';
                this.moveDraggable({...event, dx: event.deltaRect.left/2, dy: event.deltaRect.top/2});
            } else {
                event.target.style.scale = scale;
                event.target.setAttribute("data-w", event.target.offsetWidth);
                event.target.setAttribute("data-h", event.target.offsetHeight);
            }
        },

        moveRotation(event) {
            let element = event.target.parentElement;
            // let pos = {
            //     x: parseFloat(box.getAttribute('data-x')) || 0,
            //     y: parseFloat(box.getAttribute('data-y')) || 0
            // };
            // let startAngle = parseFloat(element.getAttribute('data-angle')) || 0;
            let center = {
                x: parseFloat(element.getAttribute('data-rotation-center-x')) || 0,
                y: parseFloat(element.getAttribute('data-rotation-center-y')) || 0
            };
            let angle;
            if (!event.clientY || !event.clientX) {
                angle = parseFloat(element.getAttribute('data-angle')) || 0;
            } else {
                angle = Math.atan2(center.y - event.clientY, center.x - event.clientX);
                angle = (angle % (2 * Math.PI)) + (2 * Math.PI);
            }
            if (this.$refs.widgetRotate && this.isRotate) {
                let deg = angle*(180/Math.PI) % 180;
                console.log("ROTZTRBAR", deg);
                if (deg > 179 || deg < 1) {
                    this.$refs.widgetRotate.hidden = false;
                    this.$refs.widgetRotate.style.top = `${element.offsetTop + element.offsetHeight/2}px`;
                    this.$refs.widgetRotate.style.left = `${element.offsetLeft + element.offsetWidth/2}px`;
                    this.$refs.widgetRotate.style.transform = `translateX(-50%) rotate(0deg)`;
                } else if (deg > 44 && deg < 46) {
                    this.$refs.widgetRotate.hidden = false;
                    this.$refs.widgetRotate.style.top = `${element.offsetTop + element.offsetHeight/2}px`;
                    this.$refs.widgetRotate.style.left = `${element.offsetLeft + element.offsetWidth/2}px`;
                    this.$refs.widgetRotate.style.transform = `translateX(-50%) rotate(45deg)`;
                } else if (deg > 89 && deg < 91) {
                    this.$refs.widgetRotate.hidden = false;
                    this.$refs.widgetRotate.style.top = `${element.offsetTop + element.offsetHeight/2}px`;
                    this.$refs.widgetRotate.style.left = `${element.offsetLeft + element.offsetWidth/2}px`;
                    this.$refs.widgetRotate.style.transform = `translateX(-50%) rotate(90deg)`;
                } else if (deg > 134 && deg < 136) {
                    this.$refs.widgetRotate.hidden = false;
                    this.$refs.widgetRotate.style.top = `${element.offsetTop + element.offsetHeight/2}px`;
                    this.$refs.widgetRotate.style.left = `${element.offsetLeft + element.offsetWidth/2}px`;
                    this.$refs.widgetRotate.style.transform = `translateX(-50%) rotate(135deg)`;
                } else {
                    this.$refs.widgetRotate.hidden = true;
                }
            } 
            console.log(center, angle, event.clientY, event.clientX);
            // angle = angle - startAngle;
            // update transform style on dragmove
            // box.style.transform = 'translate(' + pos.x + 'px, ' + pos.y + 'px) rotate(' + angle + 'rad' + ')';
            element.style.transform = 'rotate(' + angle + 'rad' + ')';
            element.setAttribute('data-angle', angle);
        },

        textSpecialsModifications(index, modifications, updatePreview=false, widgetsReel=false) {
            console.log(widgetsReel && this.storification && this.storification.widgetsReel, widgetsReel);
            
            const texts = widgetsReel && this.storification && this.storification.widgetsReel ? this.storification.widgetsReel.texts : this.texts
            let element = widgetsReel && this.storification && this.storification.widgetsReel ? this.$refs[`textReel-${index}`][0] : this.$refs[`text-${index}`][0];

            console.log("textSpecialsModifications",index, modifications, texts[index], this.texts);
            if (modifications.color != null) {
                let textBackground = modifications.background || texts[index].background;
                let textFont = modifications.font || texts[index].font;
                element.style.color = textBackground === 2 ? (['white', '#FFF', '#FFFFFF'].includes(modifications.color) ? 'black':  'white' ) : (textBackground === 1 && textFont === 3) ? 'white' : modifications.color;


                let backColor = textBackground === 2 ? modifications.color : textBackground === 1 ? (['white', '#FFF', '#FFFFFF'].includes(modifications.color) ? 'black':  'white' ) : 'transparent';
                element.style.backgroundImage = `linear-gradient(${backColor}, ${backColor}), url('')`;
                if (textFont !== 1 && textFont !== 2 && textFont !== 4) {
                    element.style.backgroundSize = 'cover';
                    element.classList.remove(`background-1-inline`);
                    element.classList.remove(`background-2-inline`);
                    element.classList.remove(`background-4-inline`);
                    // element.style.background = modifications.background === 2 ? textColor : modifications.background === 1 ? (['white', '#FFF', '#FFFFFF'].includes(textColor) ? 'black':  'white' ) : 'transparent';
                } else if (textFont === 4) {
                    element.classList.remove(`background-1-inline`);
                    element.classList.remove(`background-2-inline`);
                    element.classList.add(`background-4-inline`);
                    // element.style.background = 'transparent';
                    element.style.backgroundSize = 0;
                } else if (textFont === 2) {
                    element.classList.remove(`background-4-inline`);
                    element.classList.remove(`background-1-inline`);
                    element.classList.add(`background-2-inline`);
                    // element.style.background = 'transparent';
                    element.style.backgroundSize = 0;
                }
                else {
                    element.classList.remove(`background-4-inline`);
                    element.classList.remove(`background-2-inline`);
                    element.classList.add(`background-1-inline`);
                    // element.style.background = 'transparent';
                    element.style.backgroundSize = 0;
                }


                element.style.textShadow =  textBackground === 1 && textFont === 3 ? '1px 1px 2px black, 0 0 10px ' + (modifications.color.includes('#') ? modifications.color : ['black', '#000', '#000000'].includes(modifications.color) ? '#000000' : '#FFFFFF') + ', 0 0 1px' + (modifications.color.includes('#') ? modifications.color : ['black', '#000', '#000000'].includes(modifications.color) ? '#000000' : '#FFFFFF') : 'none';

            }
            if (modifications.background != null) {
                let textColor = modifications.color || texts[index].color;
                let textFont = modifications.font || texts[index].font;
                
                // element.style.backgroundColor = modifications.background === 2 ? textColor : modifications.background === 1 ? (['white', '#FFF', '#FFFFFF'].includes(textColor) ? 'black':  'white' ) : 'transparent';
                // element.style.backgroundImage = modifications.background === 2 ? textColor : modifications.background === 1 ? (['white', '#FFF', '#FFFFFF'].includes(textColor) ? 'black':  'white' ) : 'transparent';
                let backColor = modifications.background === 2 ? textColor : modifications.background === 1 ? (['white', '#FFF', '#FFFFFF'].includes(textColor) ? 'black':  'white' ) : 'transparent';
                element.style.backgroundImage = `linear-gradient(${backColor}, ${backColor}), url('')`;
                if (textFont !== 1 && textFont !== 2 && textFont !== 4) {
                    element.style.backgroundSize = 'cover';
                    element.classList.remove(`background-1-inline`);
                    element.classList.remove(`background-2-inline`);
                    element.classList.remove(`background-4-inline`);
                    // element.style.background = modifications.background === 2 ? textColor : modifications.background === 1 ? (['white', '#FFF', '#FFFFFF'].includes(textColor) ? 'black':  'white' ) : 'transparent';
                } else if (textFont === 4) {
                    element.classList.remove(`background-1-inline`);
                    element.classList.remove(`background-2-inline`);
                    element.classList.add(`background-4-inline`);
                    // element.style.background = 'transparent';
                    element.style.backgroundSize = 0;
                } else if (textFont === 2) {
                    element.classList.remove(`background-4-inline`);
                    element.classList.remove(`background-1-inline`);
                    element.classList.add(`background-2-inline`);
                    // element.style.background = 'transparent';
                    element.style.backgroundSize = 0;
                }
                else {
                    element.classList.remove(`background-4-inline`);
                    element.classList.remove(`background-2-inline`);
                    element.classList.add(`background-1-inline`);
                    // element.style.background = 'transparent';
                    element.style.backgroundSize = 0;
                }
                element.style.color = modifications.background === 2 ? (['white', '#FFF', '#FFFFFF'].includes(textColor) ? 'black':  'white' ) : (modifications.background === 1 && textFont === 3) ? 'white' : textColor;
                console.log(modifications.background === 1 && textFont === 3);
                let ee =  (modifications.background === 1 && textFont === 3) ? ('1px 1px 2px black, 0 0 10px ' + (textColor.includes('#') ? textColor : (['black', '#000', '#000000'].includes(textColor) ? '#000000' : '#FFFFFF')) + (', 0 0 1px ' + (textColor.includes('#') ? textColor : (['black', '#000', '#000000'].includes(textColor) ? '#000000' : '#FFFFFF')))) : 'none';
                console.log("ee", ee);
                element.style.textShadow = ee;
                console.log(element.style.textShadow, element);
            }
            if (modifications.font != null) {
                let textBackground = modifications.background || texts[index].background;
                let textColor = modifications.color || texts[index].color;
                let oldFont = texts[index].font;
                let backColor = textBackground === 2 ? textColor : textBackground === 1 ? (['white', '#FFF', '#FFFFFF'].includes(textColor) ? 'black':  'white' ) : 'transparent';
                element.style.backgroundImage = `linear-gradient(${backColor}, ${backColor}), url('')`;
                
                if (modifications.font !== 1 && modifications.font !== 2 && modifications.font !== 4) {
                    element.style.backgroundSize = 'cover';
                    element.classList.remove(`background-1-inline`);
                    element.classList.remove(`background-2-inline`);
                    element.classList.remove(`background-4-inline`);
                    // element.style.background = modifications.background === 2 ? textColor : modifications.background === 1 ? (['white', '#FFF', '#FFFFFF'].includes(textColor) ? 'black':  'white' ) : 'transparent';
                } else if (modifications.font === 4) {
                    element.classList.remove(`background-1-inline`);
                    element.classList.remove(`background-2-inline`);
                    setTimeout(() => {
                        element.classList.add(`background-4-inline`);
                    }, 100)
                    // element.style.background = 'transparent';
                    element.style.backgroundSize = 0;
                } else if (modifications.font === 2) {
                    element.classList.remove(`background-1-inline`);
                    element.classList.remove(`background-4-inline`);
                    setTimeout(() => {
                        element.classList.add(`background-2-inline`);
                    }, 100)
                    // element.style.background = 'transparent';
                    element.style.backgroundSize = 0;
                } else {
                    element.classList.remove(`background-4-inline`);
                    element.classList.remove(`background-2-inline`);
                    setTimeout(() => {
                        element.classList.add(`background-1-inline`);
                    }, 100)
                    
                    // element.style.background = 'transparent';
                    element.style.backgroundSize = 0;
                }
                element.classList.remove(`font${oldFont}`);
                element.classList.add(`font${modifications.font}`);
                element.style.color = textBackground === 2 ? (['white', '#FFF', '#FFFFFF'].includes(textColor) ? 'black':  'white' ) : (textBackground === 1 && modifications.font === 3) ? 'white' : textColor;
                element.style.textShadow =  textBackground === 1 && modifications.font === 3 ? '1px 1px 2px black, 0 0 10px ' + (textColor.includes('#') ? textColor : ['black', '#000', '#000000'].includes(textColor) ? '#000000' : '#FFFFFF') + ', 0 0 1px' + (textColor.includes('#') ? textColor : ['black', '#000', '#000000'].includes(textColor) ? '#000000' : '#FFFFFF') : 'none';
            }
            if (modifications.size != null) {
                element.style.fontSize = `${modifications.size}px`;
                if (this.selectedObject === parseInt(index)) {
                    let minWidth = element.getBoundingClientRect().width;
                    modifications.minWidth = minWidth;
                }
            }
            if (!updatePreview) {
                modifications.index = index;
                this.story && this.story.isReel ? this.$store.commit(`updateStorificationTextReel`, modifications) : this.$store.commit(`updateStorificationText`, modifications);
            }
        },

        //For color styles define (color= 0|1|2...)
        changeColor(event, color=null, updatePreview=false) {
            let element = event.currentTarget;
            let moduloColor = parseInt(element.getAttribute('data-number-style-color'));
            console.log(this.changeColor, moduloColor);
            [...element.classList].some(e => {
                const pattern = `style-color-(?:0|[1-9]\\d{0,${Math.floor(Math.log10(moduloColor))}}|${moduloColor})`;
                if (new RegExp(pattern).test(e)) {
                    if (color === null) color = (parseInt(e.split('-').pop()) + 1) % moduloColor;
                    element.classList.remove(e);
                    element.classList.add(`style-color-${color}`)
                    return true;
                }
            });
            if (!updatePreview) {
                if (!color) color = 0;
                let name = element.getAttribute('data-name');
                let index = element.getAttribute('data-index');
                this.story && this.story.isReel && ["Text", "Gif", "Music"].includes(name) ? this.$store.commit(`updateStorification${name}Reel`, {index, color}) : this.$store.commit(`updateStorification${name}`, {index, color});
            }
        },

        updateStoreWithPosition(event) {
            console.log("updateStoreWithPosition");
            let x = parseFloat(event.target.getAttribute('data-x') ? event.target.getAttribute('data-x') : (event.target.offsetWidth/2));
            let y = parseFloat(event.target.getAttribute('data-y') ? event.target.getAttribute('data-y') : (event.target.offsetHeight/2));
            let scale = parseFloat(event.target.getAttribute('data-scale') || 1);
            let w = parseFloat(event.target.getAttribute('data-w'));
            let h = parseFloat(event.target.getAttribute('data-h'));
            let angle = parseFloat(event.target.getAttribute('data-angle') || 0);
            let name = event.target.getAttribute('data-name');
            let index = event.target.getAttribute('data-index');
            console.log(event.target,{index, x, y, scale, w, h, angle});
            this.story && this.story.isReel && ["Text", "Gif", "Music"].includes(name) ? this.$store.commit(`updateStorification${name}Reel`, {index, x, y, scale, w, h, angle}) : this.$store.commit(`updateStorification${name}`, {index, x, y, scale, w, h, angle});
        },

        updatePreview(name, values, index=null) {
            console.log(values, index, name);
            let elmt;
            const timeout = 10000
            let elapsedTime = 0;
            if (values) {
                this.$vs.loading({container: this.$refs['screen-instagram'], color: '#43153D'})
                let waitElement = setInterval(() => {
                    elapsedTime += 100
                    if (index != null) {
                        elmt = this.$el.querySelector(`[data-name="${name}"][data-index="${index}"]`);
                    } else {
                        elmt = this.$el.querySelector(`[data-name="${name}"]`);
                    }
                    if (elmt) {
                        clearInterval(waitElement);
                        // elmt.style.top = `${values.y - (elmt.offsetHeight/2)}px`;
                        elmt.style.top = `${values.y}px`;
                        // elmt.style.left = `${values.x - (elmt.offsetWidth/2)}px`;
                        elmt.style.left = `${values.x}px`;
                        if (values.scale === 1 && namesNeedUseWidth.includes(name)) {
                            console.log("width");
                            elmt.style.width = `${values.w}px`;
                            // elmt.style.height = `${values.h}px`;
                        }
                        
                        elmt.style.scale = values.scale;
                        elmt.style.transform = 'rotate(' + values.angle + 'rad' + ')';
                        if (values.color != null) {
                            this.changeColor({currentTarget: elmt}, values.color, true);
                        } 
                        // && [...elmt.classList].some(e => /style-color-[0-3]/.test(e) && (elmt.classList.remove(e) || elmt.classList.add(`style-color-${values.color}`)));
                        if (name === "Text") this.textSpecialsModifications(index, values, true);
                        if (name === "TextReel") this.textSpecialsModifications(index, values, true, true);
                        this.$vs.loading.close(this.$refs['screen-instagram']);
                    } else if (elapsedTime >= timeout) {
                        console.log("Preview Timeout", name, values, index);
                        this.$vs.loading.close(this.$refs['screen-instagram']);
                        clearInterval(waitElement);
                    }
                }, 100)
            }
        },

        setMod(mod) {
            console.log("SETMOD", mod);
            this.currentMod = mod;
        },

        async loadImageError(e, origin=false) {
            console.log("@error=loadImageError origin:", origin);
            let img = e.target;
            if (origin) {
                img.crossOrigin = undefined;
            }
            img.onerror = () => this.loadImageError(e, true);
            if (!img.src.includes("timestamp")) {
                img.src += `?timestamp=${new Date().getTime()}`
            } else if (!img.src.includes("base64")) {
                await this.repairCorsImage(img.src);
                // this.$vs.loading({container: this.$refs['screen-instagram'], color: '#43153D'})
                // let res = await this.getImageFromUrl(encodeURIComponent(img.src));
                // this.$vs.loading.close(this.$refs['screen-instagram']);
                // img.src = res.body.image;
            }
        },

        async loadVideo(e, storification=false) {
            if (storification) {
                e.target.nextSibling.style = `top: ${e.target.parentElement.offsetHeight/2 + e.target.clientHeight/2 + 10}px; left: 20%;`;
                if (this.storification.isCarousel){
                    e.target.parentElement.getElementsByClassName("carousel-storification")[0].style = `top: ${e.target.parentElement.offsetHeight/2 - e.target.clientHeight/2 + 7}px; left: ${e.target.parentElement.offsetWidth/2 + e.target.clientWidth/2 - 30}px;`;
                }
                e.target.parentElement.getElementsByClassName("video-time")[0].style = `top: ${e.target.parentElement.offsetHeight/2 - e.target.clientHeight/2 + 10}px; left: ${e.target.parentElement.offsetWidth/2 + e.target.clientWidth/2 - 30}px;`
                e.target.parentElement.getElementsByClassName("reel-storification-icon")[0].style = `top: ${e.target.parentElement.offsetHeight/2 - e.target.clientHeight/2 + 7}px; left: ${e.target.parentElement.offsetWidth/2 - e.target.clientWidth/2 + 5}px;`
                e.target.addEventListener('timeupdate', () => {
                    if (e.target.currentTime >= 15) {
                        e.target.currentTime = 0;
                    }
                    let subTime = e.target.duration-e.target.currentTime;
                    this.currentStorificationVideoTime = `${Math.floor(subTime/60)}:${Math.floor(subTime%60).toString().padStart(2, '0')}`;
                }, false);
                const fac = new FastAverageColor();
                let res = await this.getImageFromUrl(encodeURIComponent(e.target.src));
                console.log(res);
                const vid = document.createElement("video");
                vid.crossOrigin = 'anonymous';
                vid.src = (res.body.image);
                vid.muted = true;
                await vid.play();
                let c = document.createElement('canvas')
                c.height = vid.videoHeight || parseInt(vid.style.height)
                c.width = vid.videoWidth || parseInt(vid.style.width)
                const ctx = c.getContext('2d')
                console.log(ctx);
                ctx.drawImage(vid, 0, 0)
                console.log(c.toDataURL());
                let facColor = await fac.getColorAsync(c.toDataURL());
                let colors = facColor.hex;
                console.log(colors);
                if (colors && !this.backgroundColor) {
                    this.$store.commit(`updateStorificationBackgroundColor`, colors);
                }
            }
        },

        async loadImage(e, storification=false) {
            if (storification) {
                e.target.nextSibling.style = `top: ${e.target.parentElement.offsetHeight/2 + e.target.height/2 + 10}px`;
                e.target.parentElement.getElementsByClassName("carousel-storification")[0].style = `top: ${e.target.parentElement.offsetHeight/2 - e.target.height/2 + 7}px; left: ${e.target.parentElement.offsetWidth/2 + e.target.width/2 - 30}px;`
            }
            if (!this.backgroundColor) {
                let colors
                // let colorThief = new ColorThief();
                const fac = new FastAverageColor();
                let facColor = fac.getColor(e.target, {defaultColor: ["null","null","null","null"]});
                console.log("ooo", facColor);
                colors = facColor.hex;
                    // colors = colorThief.getColor(e.target);
                    // console.log(colors, e.target);
                    // colors = "#" + colors[0].toString(16).padStart(2, "0") + colors[1].toString(16).padStart(2, "0") + colors[2].toString(16).padStart(2, "0");
                if (colors === "#nullnullnull") {
                    // console.log("AA/",err);
                    document.querySelectorAll(`canvas[width="${screenSize.width}"][height="${screenSize.height}"]`).forEach(e => e.remove());
                    // if ((err.message.includes('The operation is insecure') || err.message.includes('The canvas has been tainted by cross-origin data')) && this.link.url) {
                        await this.repairCorsImage(e.target.src);
                        return;
                    // } else {
                        // colors = '#000000';
                    // }
                }
                // e.target.parentElement.style =  `background: linear-gradient(${colors[0]}, ${colors[1]})`;
                this.$store.commit(`updateStorificationBackgroundColor`, colors);
            } else if (e.target.src.startsWith('https://') && !e.target.src.startsWith('https://s3-eu-west-1.amazonaws.com/saas.mashup/uploads')) {
                this.$vs.loading({container: this.$refs['screen-instagram'], color: '#43153D'})
                let res = await this.getImageFromUrl(encodeURIComponent(e.target.src));
                this.$vs.loading.close(this.$refs['screen-instagram']);
                const newImageBlob = await fetch(res.body.image).then(res => res.blob())
                this.$store.dispatch(`emitData`, {message: "updateCroppedImage", data: newImageBlob})
            }
        },

        async repairCorsImage(src) {
            console.log("repairCorsImage");
            this.$vs.loading({container: this.$refs['screen-instagram'], color: '#43153D'})
            let res = await this.getImageFromUrl(encodeURIComponent(src));
            this.$vs.loading.close(this.$refs['screen-instagram']);
            const img = document.createElement("img");
            img.onload = async (ee) => {
                const fac = new FastAverageColor();
                let facColor = await fac.getColorAsync(ee.target);
                let colors = facColor.hex;
                console.log(colors);
                if (colors && !this.backgroundColor) {
                    this.$store.commit(`updateStorificationBackgroundColor`, colors);
                }
                return;
            }
            img.src = res.body.image;
            const newImageBlob = await fetch(res.body.image).then(res => res.blob())
            this.$store.dispatch(`emitData`, {message: "updateCroppedImage", data: newImageBlob})
        },

        initDatas() {
            this.$el.querySelectorAll(`.text`).forEach(element => {
                 //Init default values
                let color = '#FFFFFF';
                let font = 1;
                let size = 20;
                let background = 0;

                // Get Initial give value if exists
                let initialDatas = element.getAttribute("data-init");
                if (initialDatas) {
                    initialDatas = JSON.parse(initialDatas);
                    if (initialDatas.color != null) {
                        color = initialDatas.color;
                    }
                    if (initialDatas.font != null) {
                        font = initialDatas.font;
                    }
                    if (initialDatas.size != null) {
                        size = initialDatas.size;
                    }
                    if (initialDatas.background != null) {
                        background = initialDatas.background
                    }
                }
                console.log(initialDatas, !!initialDatas, typeof initialDatas, color);
                let index = element.getAttribute("data-index");

                //Init color
                this.textSpecialsModifications(index, {color, font, size, background});
            });
            this.$el.querySelectorAll(`.colorable-${this._uid}`).forEach(element => {
                //Init default values
                let color = 0;

                // Get Initial give value if exists
                let initialDatas = element.getAttribute("data-init");
                if (initialDatas) {
                    initialDatas = JSON.parse(initialDatas);
                    if (initialDatas.color != null) {
                        color = initialDatas.color
                    }
                }
                console.log(initialDatas, !!initialDatas, typeof initialDatas, color);

                //Init color
                this.changeColor({currentTarget: element}, color)
            });
            this.$el.querySelectorAll(`.draggable-${this._uid}`).forEach(element => {
                //Init default values
                let x = (screenSize.width / 2) - (element.offsetWidth/2);
                let y = (screenSize.height / 4) - (element.offsetHeight/2);
                let w = element.offsetWidth;
                let h = element.offsetHeight;

                
                // Get Initial give value if exists
                let initialDatas = element.getAttribute("data-init");
                if (initialDatas) {
                    initialDatas = JSON.parse(initialDatas);
                    if (initialDatas.x != null && initialDatas.y != null) {
                        ({ x, y } = initialDatas);
                    }
                    if (initialDatas.w != null && initialDatas.h != null) {
                        let angle = initialDatas.angle || 0;
                        w = (initialDatas.w * Math.abs(Math.cos(angle))) + (initialDatas.h * Math.abs(Math.sin(angle)));
                        h = (initialDatas.w * Math.abs(Math.sin(angle))) + (initialDatas.h * Math.abs(Math.cos(angle)));
                        // ({ w, h } = initialDatas);
                    }
                }
                console.log(initialDatas, !!initialDatas, typeof initialDatas, x, y, element.getAttribute('data-name'));

                //Init position
                element.setAttribute("data-x", x)
                element.setAttribute("data-y", y)
                const evt = {dx: 0, dy: 0, target: element, rect: {width: w, height: h}};
                this.moveDraggable(evt);
                this.updateStoreWithPosition(evt);
            });
            this.$el.querySelectorAll(`.resizable-${this._uid}`).forEach(element => {
                //Init default values
                let scale = 1;
                let w = element.offsetWidth;
                let h = element.offsetHeight;
                let angle = 0;
                
                // Get Initial give value if exists
                let initialDatas = element.getAttribute("data-init");
                if (initialDatas) {
                    initialDatas = JSON.parse(initialDatas);
                    if (initialDatas.scale != null) {
                        scale = initialDatas.scale;
                    }
                    if (initialDatas.angle != null) {
                        angle = initialDatas.angle
                    }
                    if (initialDatas.w != null && initialDatas.h != null) {
                        w = (initialDatas.w * Math.abs(Math.cos(angle))) + (initialDatas.h * Math.abs(Math.sin(angle)));
                        h = (initialDatas.w * Math.abs(Math.sin(angle))) + (initialDatas.h * Math.abs(Math.cos(angle)));
                        // ({ w, h } = initialDatas);
                    }
                    
                }
                console.log(initialDatas, !!initialDatas, typeof initialDatas, scale, element.offsetWidth, w);

                //Init position
                element.setAttribute("data-angle", angle);
                element.setAttribute("data-scale", scale)
                const evt = {target: element, rect: {width: w*scale, height: h*scale}, deltaRect: {left: 0, top: 0}};
                setTimeout(() => {
                    this.moveResizable(evt, namesNeedUseWidth.includes(element.getAttribute('data-name')));
                    this.updateStoreWithPosition(evt);
                }, 100);
            });
            this.$el.querySelectorAll(`.rotation-${this._uid}`).forEach(elementRotate => {
                const element = elementRotate.parentElement;
                let angle = 0;
                let initialDatas = element.getAttribute("data-init");
                if (initialDatas) {
                    initialDatas = JSON.parse(initialDatas);
                    if (initialDatas.angle != null) {
                        angle = initialDatas.angle;
                    }
                }
                console.log(initialDatas, !!initialDatas, typeof initialDatas, angle);
                element.setAttribute("data-angle", angle);
                this.moveRotation({target: elementRotate});
                this.updateStoreWithPosition({target: element})
            });
        
        }
        
    },

    computed: {
        currentHighlightThumbnail() {
            return this.highlight.current && this.highlight.current !== '__new_highlight__' && this.highlight.pages && this.highlight.pages.length ? this.highlight.pages.find(e => e.id === this.highlight.current).img : require('../../assets/img/icon_instagram_highlight.png');
        },
        isValidHightlight() {
            let h = this.highlight.pages.map(e => e.title);
            return (this.highlight.current === '__new_highlight__' && this.highlight.create !== '' && !h.includes(this.highlight.create)) || this.highlight.current !== '__new_highlight__';
        },
        positionMusicBar() {
            return this.music ? `${-419 + ((100 - ((this.music.start / (this.music.track.duration_in_ms - (this.music.end-this.music.start))) * 100)) / 100) * (105 - (-419))}px` : ''
        },
        musicPreview() {
          return this.music ? [this.music.track.display_artist, (this.music.track.display_artist + this.music.track.title).length > 30 ? this.music.track.title.substring(0,  this.music.track.title.length - ((this.music.track.display_artist + this.music.track.title).length-30)) + '...' : this.music.track.title] : ['',''];
        },
        musicReelPreview() {
          return this.storification.widgetsReel.music ? [this.storification.widgetsReel.music.track.display_artist, (this.storification.widgetsReel.music.track.display_artist + this.storification.widgetsReel.music.track.title).length > 30 ? this.storification.widgetsReel.music.track.title.substring(0,  this.storification.widgetsReel.music.track.title.length - ((this.storification.widgetsReel.music.track.display_artist + this.storification.widgetsReel.music.track.title).length-30)) + '...' : this.storification.widgetsReel.music.track.title] : ['',''];
        },
        isVideo() {
            return (this.story && this.story.video) || (this.storification && this.storification.video)
        },
        pollHasQuestion() {
            return this.poll && this.poll.question.length > 0;
        },
        textsComputed() {
            if (!this.informations.mentions) return this.texts.map(el => el.content);
            let previewsArray = [];
            const texts = this.texts
            for (let txt of texts) {
                let preview = txt.content;
                if (this.informations.acceptReplaceHashtag && Array.isArray(this.informations.mentions.hashtagsAuto)) {
                    for (let tag of this.informations.mentions.hashtagsAuto) {
                        let regex = new RegExp("( |^)" + tag.correspondences.join('( |$)|( |^)') + "( |$)", 'g')
                        preview = txt.content.replaceAll(regex, ' #'+tag.hashtag+' ').trim()
                    }
                }
                if (this.informations.acceptPrefix) {
                    preview = this.informations.mentions.hashtagPrefix + " " + preview + " " + this.informations.mentions.hashtag;
                }
                const regexMention = /@\[MENTIONS-([0-9]*)\]/g;
                const matchMentions = preview.match(regexMention) || []
                for (let m of matchMentions) {
                    preview = preview.replace(m, this.informations.validMentions[parseInt(m.slice(-2)[0])-1][0].value);
                }
                const regexHashtag = /#\[HASHTAGS-([0-9]*)\]/g;
                const matchHashtag = preview.match(regexHashtag) || []
                for (let m of matchHashtag) {
                    preview = preview.replace(m, this.informations.validHashtags[parseInt(m.slice(-2)[0])-1][0].value);
                }
                previewsArray.push(preview);
            }
            return  previewsArray;
        },
        textsReelComputed() {
            if (!this.informations.mentions) return this.texts.map(el => el.content);
            let previewsArray = [];
            const texts = this.storification && this.storification.widgetsReel && this.storification.widgetsReel.texts
            for (let txt of texts) {
                let preview = txt.content;
                if (this.informations.acceptReplaceHashtag && Array.isArray(this.informations.mentions.hashtagsAuto)) {
                    for (let tag of this.informations.mentions.hashtagsAuto) {
                        let regex = new RegExp("( |^)" + tag.correspondences.join('( |$)|( |^)') + "( |$)", 'g')
                        preview = txt.content.replaceAll(regex, ' #'+tag.hashtag+' ').trim()
                    }
                }
                if (this.informations.acceptPrefix) {
                    preview = this.informations.mentions.hashtagPrefix + " " + preview + " " + this.informations.mentions.hashtag;
                }
                const regexMention = /@\[MENTIONS-([0-9]*)\]/g;
                const matchMentions = preview.match(regexMention) || []
                for (let m of matchMentions) {
                    preview = preview.replace(m, this.informations.validMentions[parseInt(m.slice(-2)[0])-1][0].value);
                }
                const regexHashtag = /#\[HASHTAGS-([0-9]*)\]/g;
                const matchHashtag = preview.match(regexHashtag) || []
                for (let m of matchHashtag) {
                    preview = preview.replace(m, this.informations.validHashtags[parseInt(m.slice(-2)[0])-1][0].value);
                }
                previewsArray.push(preview);
            }
            return  previewsArray;
        },

        pageIsConnectedConciergerie() {
           return  (this.informations.pageInfo.story_config && this.informations.pageInfo.story_config.created && (!this.informations.pageInfo.story_config.lock || this.informations.pageInfo.story_config.lock < Date.now()))
        },

        screenshotPuppeteer() {
            return !!(localStorage && localStorage.preview_overlay && !localStorage.screenshot);
        }
    }
}
</script>
